import { t as n } from "./isDefined-fMi6eQ4r.js";
import { clsx as L } from "clsx";
import { jsx as y } from "react/jsx-runtime";
import { isFunction as P, isNonEmptyString as H, isObject as A, isString as B } from "@sniptt/guards";
import e from "react";
var Z = { duration: {
  instant: 0.075,
  fast: 0.15,
  normal: 0.3,
  slow: 1.5
} }, Y = "gray", J = {
  gray1: "color(display-p3 0.09 0.09 0.09)",
  gray2: "color(display-p3 0.106 0.106 0.106)",
  gray3: "color(display-p3 0.098 0.098 0.098)",
  gray4: "color(display-p3 0.114 0.114 0.114)",
  gray5: "color(display-p3 0.133 0.133 0.133)",
  gray6: "color(display-p3 0.282 0.282 0.282)",
  gray7: "color(display-p3 0.298 0.298 0.298)",
  gray8: "color(display-p3 0.4 0.4 0.4)",
  gray9: "color(display-p3 0.506 0.506 0.506)",
  gray10: "color(display-p3 0.482 0.482 0.482)",
  gray11: "color(display-p3 0.702 0.702 0.702)",
  gray12: "color(display-p3 0.922 0.922 0.922)"
}, U = {
  gray1: "color(display-p3 1 1 1)",
  gray2: "color(display-p3 0.988 0.988 0.988)",
  gray3: "color(display-p3 0.976 0.976 0.976)",
  gray4: "color(display-p3 0.945 0.945 0.945)",
  gray5: "color(display-p3 0.922 0.922 0.922)",
  gray6: "color(display-p3 0.839 0.839 0.839)",
  gray7: "color(display-p3 0.8 0.8 0.8)",
  gray8: "color(display-p3 0.702 0.702 0.702)",
  gray9: "color(display-p3 0.6 0.6 0.6)",
  gray10: "color(display-p3 0.514 0.514 0.514)",
  gray11: "color(display-p3 0.4 0.4 0.4)",
  gray12: "color(display-p3 0.2 0.2 0.2)"
}, Q = [
  "red",
  "ruby",
  "crimson",
  "tomato",
  "orange",
  "amber",
  "yellow",
  "lime",
  "grass",
  "green",
  "jade",
  "mint",
  "turquoise",
  "cyan",
  "sky",
  "blue",
  "iris",
  "violet",
  "purple",
  "plum",
  "pink",
  "bronze",
  "gold",
  "brown",
  "gray"
], X = 768, rr = (r, o) => {
  const a = r.replace(/^#/, ""), l = a.length === 3 || a.length === 4 ? a.split("").map((t) => t + t).join("") : a;
  return `rgba(${parseInt(l.slice(0, 2), 16)},${parseInt(l.slice(2, 4), 16)},${parseInt(l.slice(4, 6), 16)},${o})`;
}, m = (...r) => r.map((o) => `${o * 4}px`).join(" "), or = {
  icon: {
    size: {
      sm: 14,
      md: 16,
      lg: 20,
      xl: 24
    },
    stroke: {
      sm: 1.6,
      md: 2,
      lg: 2.5
    }
  },
  modal: { size: {
    sm: { width: "300px" },
    md: { width: "400px" },
    lg: { width: "53%" },
    xl: {
      width: "1200px",
      height: "800px"
    },
    fullscreen: {
      width: "calc(100dvw / var(--t-zoom, 1))",
      height: "calc(100dvh / var(--t-zoom, 1))"
    }
  } },
  text: {
    lineHeight: {
      lg: 1.5,
      md: 1.1
    },
    iconSizeMedium: 16,
    iconSizeSmall: 14,
    iconStrikeLight: 1.6,
    iconStrikeMedium: 2,
    iconStrikeBold: 2.5
  },
  tooltip: {
    background: "color(display-p3 0 0 0 / 0.72)",
    color: "color(display-p3 1 1 1 / 1)",
    descriptionColor: "color(display-p3 1 1 1 / 0.64)"
  },
  animation: { duration: {
    instant: 0.075,
    fast: 0.15,
    normal: 0.3,
    slow: 1.5
  } },
  spacingMultiplicator: 4,
  spacing: m,
  betweenSiblingsGap: "2px",
  table: {
    horizontalCellMargin: "8px",
    checkboxColumnWidth: "32px",
    horizontalCellPadding: "8px"
  },
  sidePanelWidth: "500px",
  clickableElementBackgroundTransition: "background 0.1s ease",
  lastLayerZIndex: 2147483647,
  buttons: { secondaryTextColor: "color(display-p3 0.63 0.69 1)" }
}, ar = {
  icon: {
    size: {
      sm: 14,
      md: 16,
      lg: 20,
      xl: 24
    },
    stroke: {
      sm: 1.6,
      md: 2,
      lg: 2.5
    }
  },
  modal: { size: {
    sm: { width: "300px" },
    md: { width: "400px" },
    lg: { width: "53%" },
    xl: {
      width: "1200px",
      height: "800px"
    },
    fullscreen: {
      width: "calc(100dvw / var(--t-zoom, 1))",
      height: "calc(100dvh / var(--t-zoom, 1))"
    }
  } },
  text: {
    lineHeight: {
      lg: 1.5,
      md: 1.1
    },
    iconSizeMedium: 16,
    iconSizeSmall: 14,
    iconStrikeLight: 1.6,
    iconStrikeMedium: 2,
    iconStrikeBold: 2.5
  },
  tooltip: {
    background: "color(display-p3 0 0 0 / 0.72)",
    color: "color(display-p3 1 1 1 / 1)",
    descriptionColor: "color(display-p3 1 1 1 / 0.64)"
  },
  animation: { duration: {
    instant: 0.075,
    fast: 0.15,
    normal: 0.3,
    slow: 1.5
  } },
  spacingMultiplicator: 4,
  spacing: m,
  betweenSiblingsGap: "2px",
  table: {
    horizontalCellMargin: "8px",
    checkboxColumnWidth: "32px",
    horizontalCellPadding: "8px"
  },
  sidePanelWidth: "500px",
  clickableElementBackgroundTransition: "background 0.1s ease",
  lastLayerZIndex: 2147483647,
  buttons: { secondaryTextColor: "color(display-p3 0.63 0.69 1)" },
  accent: {
    primary: "color(display-p3 0.163 0.22 0.439)",
    secondary: "color(display-p3 0.163 0.22 0.439)",
    tertiary: "color(display-p3 0.105 0.141 0.275)",
    quaternary: "color(display-p3 0.081 0.089 0.144)",
    accent3570: "color(display-p3 0.285 0.362 0.674)",
    accent4060: "color(display-p3 0.285 0.362 0.674)",
    accent1: "color(display-p3 0.068 0.074 0.118)",
    accent2: "color(display-p3 0.081 0.089 0.144)",
    accent3: "color(display-p3 0.105 0.141 0.275)",
    accent4: "color(display-p3 0.129 0.18 0.369)",
    accent5: "color(display-p3 0.163 0.22 0.439)",
    accent6: "color(display-p3 0.203 0.262 0.5)",
    accent7: "color(display-p3 0.245 0.309 0.575)",
    accent8: "color(display-p3 0.285 0.362 0.674)",
    accent9: "color(display-p3 0.276 0.384 0.837)",
    accent10: "color(display-p3 0.354 0.445 0.866)",
    accent11: "color(display-p3 0.63 0.69 1)",
    accent12: "color(display-p3 0.848 0.881 0.99)"
  },
  background: {
    noisy: "var(--t-background-noisy)",
    primary: "color(display-p3 0.09 0.09 0.09)",
    secondary: "color(display-p3 0.106 0.106 0.106)",
    tertiary: "color(display-p3 0.114 0.114 0.114)",
    quaternary: "color(display-p3 0.133 0.133 0.133)",
    invertedPrimary: "color(display-p3 0.922 0.922 0.922)",
    invertedSecondary: "color(display-p3 0.702 0.702 0.702)",
    danger: "color(display-p3 0.211 0.081 0.099)",
    transparent: {
      primary: "color(display-p3 0 0 0 / 0.5)",
      secondary: "color(display-p3 0 0 0 / 0.4)",
      strong: "color(display-p3 1 1 1 / 0.141)",
      medium: "color(display-p3 1 1 1 / 0.102)",
      light: "color(display-p3 1 1 1 / 0.059)",
      lighter: "color(display-p3 1 1 1 / 0.031)",
      danger: "#ff173f2d",
      blue: "#3566ff57",
      orange: "#ff590039",
      success: "#11ff992d"
    },
    overlayPrimary: "#000000b8",
    overlaySecondary: "#0000005c",
    overlayTertiary: "#0000005c",
    radialGradient: "radial-gradient(50% 62.62% at 50% 0%, color(display-p3 0.506 0.506 0.506) 0%, color(display-p3 0.482 0.482 0.482) 100%)",
    radialGradientHover: "radial-gradient(76.32% 95.59% at 50% 0%, color(display-p3 0.482 0.482 0.482) 0%, color(display-p3 0.702 0.702 0.702) 100%)",
    primaryInverted: "color(display-p3 0.922 0.922 0.922)",
    primaryInvertedHover: "color(display-p3 0.702 0.702 0.702)"
  },
  blur: {
    light: "blur(6px) saturate(200%) contrast(100%) brightness(130%)",
    medium: "blur(12px) saturate(200%) contrast(100%) brightness(130%)",
    strong: "blur(20px) saturate(200%) contrast(100%) brightness(130%)"
  },
  border: {
    color: {
      strong: "color(display-p3 0.282 0.282 0.282)",
      medium: "color(display-p3 0.133 0.133 0.133)",
      light: "color(display-p3 0.114 0.114 0.114)",
      secondaryInverted: "color(display-p3 0.702 0.702 0.702)",
      inverted: "color(display-p3 0.922 0.922 0.922)",
      danger: "color(display-p3 0.348 0.11 0.142)",
      blue: "color(display-p3 0.245 0.309 0.575)",
      transparentStrong: "color(display-p3 1 1 1 / 0.071)"
    },
    radius: {
      xs: "2px",
      sm: "4px",
      md: "8px",
      smRound: "4px",
      mdRound: "8px",
      lg: "16px",
      xl: "20px",
      xxl: "40px",
      pill: "999px",
      rounded: "100%"
    }
  },
  boxShadow: {
    color: "rgba(0, 0, 0, 0.6)",
    light: "0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 0px 4px 0px rgba(0, 0, 0, 0.08)",
    sidebar: "-4px 4px 4px 0px rgba(0, 0, 0, 0.03)",
    strong: "2px 4px 16px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.08)",
    underline: "0px 1px 0px 0px rgba(0, 0, 0, 0.32)",
    superHeavy: "2px 4px 16px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.04)"
  },
  font: {
    color: {
      primary: "color(display-p3 0.922 0.922 0.922)",
      secondary: "color(display-p3 0.702 0.702 0.702)",
      tertiary: "color(display-p3 0.506 0.506 0.506)",
      light: "color(display-p3 0.4 0.4 0.4)",
      extraLight: "color(display-p3 0.298 0.298 0.298)",
      inverted: "color(display-p3 0.09 0.09 0.09)",
      onAccent: "color(display-p3 1 1 1)",
      danger: "color(display-p3 0.83 0.329 0.324)"
    },
    size: {
      xxs: "0.625rem",
      xs: "0.85rem",
      sm: "0.92rem",
      md: "1rem",
      lg: "1.23rem",
      xl: "1.54rem",
      xxl: "1.85rem"
    },
    weight: {
      regular: 400,
      medium: 500,
      semiBold: 600
    },
    family: "Inter, sans-serif"
  },
  name: "dark",
  snackBar: {
    success: {
      color: "color(display-p3 0.297 0.637 0.581)",
      backgroundColor: "#11ff992d"
    },
    error: {
      color: "color(display-p3 0.83 0.329 0.324)",
      backgroundColor: "#ff173f2d"
    },
    warning: {
      color: "color(display-p3 0.9 0.45 0.2)",
      backgroundColor: "#ff590039"
    },
    info: {
      color: "color(display-p3 0.276 0.384 0.837)",
      backgroundColor: "#3566ff57"
    },
    default: {
      color: "color(display-p3 0.922 0.922 0.922)",
      backgroundColor: "color(display-p3 1 1 1 / 0.059)"
    }
  },
  tag: {
    text: {
      gray: "color(display-p3 0.702 0.702 0.702)",
      mauve: "color(display-p3 0.707 0.7 0.735)",
      slate: "color(display-p3 0.692 0.704 0.728)",
      sage: "color(display-p3 0.685 0.709 0.697)",
      olive: "color(display-p3 0.69 0.709 0.682)",
      sand: "color(display-p3 0.707 0.703 0.68)",
      tomato: "color(display-p3 1 0.585 0.455)",
      red: "color(display-p3 1 0.57 0.55)",
      ruby: "color(display-p3 1 0.57 0.59)",
      crimson: "color(display-p3 1 0.56 0.66)",
      pink: "color(display-p3 1 0.535 0.78)",
      plum: "color(display-p3 0.86 0.602 0.933)",
      purple: "color(display-p3 0.8 0.62 1)",
      violet: "color(display-p3 0.72 0.65 1)",
      iris: "color(display-p3 0.685 0.662 1)",
      cyan: "color(display-p3 0.446 0.79 0.887)",
      turquoise: "color(display-p3 0.388 0.835 0.719)",
      sky: "color(display-p3 0.536 0.772 0.924)",
      blue: "color(display-p3 0.63 0.69 1)",
      jade: "color(display-p3 0.4 0.835 0.656)",
      green: "color(display-p3 0.434 0.828 0.573)",
      grass: "color(display-p3 0.535 0.807 0.542)",
      mint: "color(display-p3 0.482 0.825 0.733)",
      lime: "color(display-p3 0.771 0.893 0.485)",
      bronze: "color(display-p3 0.81 0.707 0.655)",
      gold: "color(display-p3 0.784 0.728 0.635)",
      brown: "color(display-p3 0.835 0.715 0.597)",
      orange: "color(display-p3 1 0.63 0.38)",
      amber: "color(display-p3 1 0.8 0.29)",
      yellow: "color(display-p3 0.948 0.885 0.392)"
    },
    background: {
      gray: "color(display-p3 0.098 0.098 0.098)",
      mauve: "color(display-p3 0.138 0.134 0.144)",
      slate: "color(display-p3 0.13 0.135 0.145)",
      sage: "color(display-p3 0.128 0.135 0.131)",
      olive: "color(display-p3 0.131 0.135 0.126)",
      sand: "color(display-p3 0.135 0.135 0.129)",
      tomato: "color(display-p3 0.205 0.097 0.083)",
      red: "color(display-p3 0.211 0.081 0.099)",
      ruby: "color(display-p3 0.208 0.088 0.117)",
      crimson: "color(display-p3 0.203 0.091 0.143)",
      pink: "color(display-p3 0.198 0.098 0.179)",
      plum: "color(display-p3 0.192 0.105 0.202)",
      purple: "color(display-p3 0.175 0.112 0.224)",
      violet: "color(display-p3 0.154 0.123 0.256)",
      iris: "color(display-p3 0.128 0.134 0.272)",
      cyan: "color(display-p3 0.073 0.168 0.209)",
      turquoise: "color(display-p3 0.087 0.175 0.165)",
      sky: "color(display-p3 0.089 0.154 0.244)",
      blue: "color(display-p3 0.105 0.141 0.275)",
      jade: "color(display-p3 0.091 0.176 0.138)",
      green: "color(display-p3 0.1 0.173 0.133)",
      grass: "color(display-p3 0.118 0.163 0.122)",
      mint: "color(display-p3 0.077 0.17 0.168)",
      lime: "color(display-p3 0.13 0.16 0.099)",
      bronze: "color(display-p3 0.147 0.132 0.125)",
      gold: "color(display-p3 0.141 0.136 0.122)",
      brown: "color(display-p3 0.151 0.13 0.115)",
      orange: "color(display-p3 0.189 0.12 0.056)",
      amber: "color(display-p3 0.178 0.128 0.049)",
      yellow: "color(display-p3 0.168 0.137 0.039)"
    }
  },
  code: {
    text: {
      gray: "color(display-p3 0.482 0.482 0.482)",
      sky: "color(display-p3 0.718 0.925 0.991)",
      pink: "color(display-p3 0.808 0.356 0.645)",
      orange: "color(display-p3 0.601 0.359 0.201)",
      green: "color(display-p3 0.365 0.456 0.25)"
    },
    font: { family: "DM Mono" }
  },
  IllustrationIcon: {
    color: {
      blue: "color(display-p3 0.354 0.445 0.866)",
      gray: "color(display-p3 0.4 0.4 0.4)"
    },
    fill: {
      blue: "color(display-p3 0.848 0.881 0.99)",
      gray: "color(display-p3 0.133 0.133 0.133)"
    }
  },
  grayScale: {
    gray1: "color(display-p3 0.09 0.09 0.09)",
    gray2: "color(display-p3 0.106 0.106 0.106)",
    gray3: "color(display-p3 0.098 0.098 0.098)",
    gray4: "color(display-p3 0.114 0.114 0.114)",
    gray5: "color(display-p3 0.133 0.133 0.133)",
    gray6: "color(display-p3 0.282 0.282 0.282)",
    gray7: "color(display-p3 0.298 0.298 0.298)",
    gray8: "color(display-p3 0.4 0.4 0.4)",
    gray9: "color(display-p3 0.506 0.506 0.506)",
    gray10: "color(display-p3 0.482 0.482 0.482)",
    gray11: "color(display-p3 0.702 0.702 0.702)",
    gray12: "color(display-p3 0.922 0.922 0.922)"
  },
  color: {
    red: "color(display-p3 0.83 0.329 0.324)",
    ruby: "color(display-p3 0.83 0.323 0.408)",
    crimson: "color(display-p3 0.843 0.298 0.507)",
    tomato: "color(display-p3 0.831 0.345 0.231)",
    orange: "color(display-p3 0.9 0.45 0.2)",
    amber: "color(display-p3 1 0.77 0.26)",
    yellow: "color(display-p3 1 0.92 0.22)",
    lime: "color(display-p3 0.78 0.928 0.466)",
    grass: "color(display-p3 0.38 0.647 0.378)",
    green: "color(display-p3 0.332 0.634 0.442)",
    jade: "color(display-p3 0.319 0.63 0.521)",
    mint: "color(display-p3 0.62 0.908 0.834)",
    turquoise: "color(display-p3 0.297 0.637 0.581)",
    cyan: "color(display-p3 0.282 0.627 0.765)",
    sky: "color(display-p3 0.585 0.877 0.983)",
    blue: "color(display-p3 0.276 0.384 0.837)",
    iris: "color(display-p3 0.357 0.357 0.81)",
    violet: "color(display-p3 0.417 0.341 0.784)",
    purple: "color(display-p3 0.523 0.318 0.751)",
    plum: "color(display-p3 0.624 0.313 0.708)",
    pink: "color(display-p3 0.775 0.297 0.61)",
    bronze: "color(display-p3 0.611 0.507 0.455)",
    gold: "color(display-p3 0.579 0.517 0.41)",
    brown: "color(display-p3 0.651 0.505 0.368)",
    gray: "color(display-p3 0.298 0.298 0.298)",
    yellow1: "color(display-p3 0.078 0.069 0.047)",
    yellow2: "color(display-p3 0.103 0.094 0.063)",
    yellow3: "color(display-p3 0.168 0.137 0.039)",
    yellow4: "color(display-p3 0.209 0.169 0)",
    yellow5: "color(display-p3 0.255 0.209 0)",
    yellow6: "color(display-p3 0.31 0.261 0.07)",
    yellow7: "color(display-p3 0.389 0.331 0.135)",
    yellow8: "color(display-p3 0.497 0.42 0.182)",
    yellow9: "color(display-p3 1 0.92 0.22)",
    yellow10: "color(display-p3 1 1 0.456)",
    yellow11: "color(display-p3 0.948 0.885 0.392)",
    yellow12: "color(display-p3 0.959 0.934 0.731)",
    green1: "color(display-p3 0.062 0.083 0.071)",
    green2: "color(display-p3 0.079 0.106 0.09)",
    green3: "color(display-p3 0.1 0.173 0.133)",
    green4: "color(display-p3 0.115 0.229 0.166)",
    green5: "color(display-p3 0.147 0.282 0.206)",
    green6: "color(display-p3 0.185 0.338 0.25)",
    green7: "color(display-p3 0.227 0.403 0.298)",
    green8: "color(display-p3 0.27 0.479 0.351)",
    green9: "color(display-p3 0.332 0.634 0.442)",
    green10: "color(display-p3 0.357 0.682 0.474)",
    green11: "color(display-p3 0.434 0.828 0.573)",
    green12: "color(display-p3 0.747 0.938 0.807)",
    turquoise1: "color(display-p3 0.059 0.083 0.079)",
    turquoise2: "color(display-p3 0.075 0.11 0.107)",
    turquoise3: "color(display-p3 0.087 0.175 0.165)",
    turquoise4: "color(display-p3 0.087 0.227 0.214)",
    turquoise5: "color(display-p3 0.12 0.277 0.261)",
    turquoise6: "color(display-p3 0.162 0.335 0.314)",
    turquoise7: "color(display-p3 0.205 0.406 0.379)",
    turquoise8: "color(display-p3 0.245 0.489 0.453)",
    turquoise9: "color(display-p3 0.297 0.637 0.581)",
    turquoise10: "color(display-p3 0.319 0.69 0.62)",
    turquoise11: "color(display-p3 0.388 0.835 0.719)",
    turquoise12: "color(display-p3 0.734 0.934 0.87)",
    sky1: "color(display-p3 0.056 0.078 0.116)",
    sky2: "color(display-p3 0.075 0.101 0.149)",
    sky3: "color(display-p3 0.089 0.154 0.244)",
    sky4: "color(display-p3 0.106 0.207 0.323)",
    sky5: "color(display-p3 0.135 0.261 0.394)",
    sky6: "color(display-p3 0.17 0.322 0.469)",
    sky7: "color(display-p3 0.205 0.394 0.557)",
    sky8: "color(display-p3 0.232 0.48 0.665)",
    sky9: "color(display-p3 0.585 0.877 0.983)",
    sky10: "color(display-p3 0.718 0.925 0.991)",
    sky11: "color(display-p3 0.536 0.772 0.924)",
    sky12: "color(display-p3 0.799 0.947 0.993)",
    blue1: "color(display-p3 0.068 0.074 0.118)",
    blue2: "color(display-p3 0.081 0.089 0.144)",
    blue3: "color(display-p3 0.105 0.141 0.275)",
    blue4: "color(display-p3 0.129 0.18 0.369)",
    blue5: "color(display-p3 0.163 0.22 0.439)",
    blue6: "color(display-p3 0.203 0.262 0.5)",
    blue7: "color(display-p3 0.245 0.309 0.575)",
    blue8: "color(display-p3 0.285 0.362 0.674)",
    blue9: "color(display-p3 0.276 0.384 0.837)",
    blue10: "color(display-p3 0.354 0.445 0.866)",
    blue11: "color(display-p3 0.63 0.69 1)",
    blue12: "color(display-p3 0.848 0.881 0.99)",
    purple1: "color(display-p3 0.09 0.068 0.103)",
    purple2: "color(display-p3 0.113 0.082 0.134)",
    purple3: "color(display-p3 0.175 0.112 0.224)",
    purple4: "color(display-p3 0.224 0.137 0.297)",
    purple5: "color(display-p3 0.264 0.167 0.349)",
    purple6: "color(display-p3 0.311 0.208 0.406)",
    purple7: "color(display-p3 0.381 0.266 0.496)",
    purple8: "color(display-p3 0.49 0.349 0.649)",
    purple9: "color(display-p3 0.523 0.318 0.751)",
    purple10: "color(display-p3 0.57 0.373 0.791)",
    purple11: "color(display-p3 0.8 0.62 1)",
    purple12: "color(display-p3 0.913 0.854 0.971)",
    pink1: "color(display-p3 0.093 0.068 0.089)",
    pink2: "color(display-p3 0.121 0.073 0.11)",
    pink3: "color(display-p3 0.198 0.098 0.179)",
    pink4: "color(display-p3 0.271 0.095 0.231)",
    pink5: "color(display-p3 0.32 0.127 0.273)",
    pink6: "color(display-p3 0.382 0.177 0.326)",
    pink7: "color(display-p3 0.477 0.238 0.405)",
    pink8: "color(display-p3 0.612 0.304 0.51)",
    pink9: "color(display-p3 0.775 0.297 0.61)",
    pink10: "color(display-p3 0.808 0.356 0.645)",
    pink11: "color(display-p3 1 0.535 0.78)",
    pink12: "color(display-p3 0.964 0.826 0.912)",
    red1: "color(display-p3 0.093 0.068 0.067)",
    red2: "color(display-p3 0.118 0.077 0.079)",
    red3: "color(display-p3 0.211 0.081 0.099)",
    red4: "color(display-p3 0.287 0.079 0.113)",
    red5: "color(display-p3 0.348 0.11 0.142)",
    red6: "color(display-p3 0.414 0.16 0.183)",
    red7: "color(display-p3 0.508 0.224 0.236)",
    red8: "color(display-p3 0.659 0.298 0.297)",
    red9: "color(display-p3 0.83 0.329 0.324)",
    red10: "color(display-p3 0.861 0.403 0.387)",
    red11: "color(display-p3 1 0.57 0.55)",
    red12: "color(display-p3 0.971 0.826 0.852)",
    orange1: "color(display-p3 0.088 0.07 0.057)",
    orange2: "color(display-p3 0.113 0.089 0.061)",
    orange3: "color(display-p3 0.189 0.12 0.056)",
    orange4: "color(display-p3 0.262 0.132 0)",
    orange5: "color(display-p3 0.315 0.168 0.016)",
    orange6: "color(display-p3 0.376 0.219 0.088)",
    orange7: "color(display-p3 0.465 0.283 0.147)",
    orange8: "color(display-p3 0.601 0.359 0.201)",
    orange9: "color(display-p3 0.9 0.45 0.2)",
    orange10: "color(display-p3 0.98 0.51 0.23)",
    orange11: "color(display-p3 1 0.63 0.38)",
    orange12: "color(display-p3 0.98 0.883 0.775)",
    gray1: "color(display-p3 0.09 0.09 0.09)",
    gray2: "color(display-p3 0.106 0.106 0.106)",
    gray3: "color(display-p3 0.098 0.098 0.098)",
    gray4: "color(display-p3 0.114 0.114 0.114)",
    gray5: "color(display-p3 0.133 0.133 0.133)",
    gray6: "color(display-p3 0.282 0.282 0.282)",
    gray7: "color(display-p3 0.298 0.298 0.298)",
    gray8: "color(display-p3 0.4 0.4 0.4)",
    gray9: "color(display-p3 0.506 0.506 0.506)",
    gray10: "color(display-p3 0.482 0.482 0.482)",
    gray11: "color(display-p3 0.702 0.702 0.702)",
    gray12: "color(display-p3 0.922 0.922 0.922)",
    mauve1: "color(display-p3 0.07 0.067 0.074)",
    mauve2: "color(display-p3 0.101 0.098 0.105)",
    mauve3: "color(display-p3 0.138 0.134 0.144)",
    mauve4: "color(display-p3 0.167 0.161 0.175)",
    mauve5: "color(display-p3 0.196 0.189 0.206)",
    mauve6: "color(display-p3 0.232 0.225 0.245)",
    mauve7: "color(display-p3 0.286 0.277 0.302)",
    mauve8: "color(display-p3 0.383 0.373 0.408)",
    mauve9: "color(display-p3 0.434 0.428 0.467)",
    mauve10: "color(display-p3 0.487 0.48 0.519)",
    mauve11: "color(display-p3 0.707 0.7 0.735)",
    mauve12: "color(display-p3 0.933 0.933 0.94)",
    slate1: "color(display-p3 0.067 0.067 0.074)",
    slate2: "color(display-p3 0.095 0.098 0.105)",
    slate3: "color(display-p3 0.13 0.135 0.145)",
    slate4: "color(display-p3 0.156 0.163 0.176)",
    slate5: "color(display-p3 0.183 0.191 0.206)",
    slate6: "color(display-p3 0.215 0.226 0.244)",
    slate7: "color(display-p3 0.265 0.28 0.302)",
    slate8: "color(display-p3 0.357 0.381 0.409)",
    slate9: "color(display-p3 0.415 0.431 0.463)",
    slate10: "color(display-p3 0.469 0.483 0.514)",
    slate11: "color(display-p3 0.692 0.704 0.728)",
    slate12: "color(display-p3 0.93 0.933 0.94)",
    sage1: "color(display-p3 0.064 0.07 0.067)",
    sage2: "color(display-p3 0.092 0.098 0.094)",
    sage3: "color(display-p3 0.128 0.135 0.131)",
    sage4: "color(display-p3 0.155 0.164 0.159)",
    sage5: "color(display-p3 0.183 0.193 0.188)",
    sage6: "color(display-p3 0.218 0.23 0.224)",
    sage7: "color(display-p3 0.269 0.285 0.277)",
    sage8: "color(display-p3 0.362 0.382 0.373)",
    sage9: "color(display-p3 0.398 0.438 0.421)",
    sage10: "color(display-p3 0.453 0.49 0.474)",
    sage11: "color(display-p3 0.685 0.709 0.697)",
    sage12: "color(display-p3 0.927 0.933 0.93)",
    olive1: "color(display-p3 0.067 0.07 0.063)",
    olive2: "color(display-p3 0.095 0.098 0.091)",
    olive3: "color(display-p3 0.131 0.135 0.126)",
    olive4: "color(display-p3 0.158 0.163 0.153)",
    olive5: "color(display-p3 0.186 0.192 0.18)",
    olive6: "color(display-p3 0.221 0.229 0.215)",
    olive7: "color(display-p3 0.273 0.284 0.266)",
    olive8: "color(display-p3 0.365 0.382 0.359)",
    olive9: "color(display-p3 0.414 0.438 0.404)",
    olive10: "color(display-p3 0.467 0.49 0.458)",
    olive11: "color(display-p3 0.69 0.709 0.682)",
    olive12: "color(display-p3 0.927 0.933 0.926)",
    sand1: "color(display-p3 0.067 0.067 0.063)",
    sand2: "color(display-p3 0.098 0.098 0.094)",
    sand3: "color(display-p3 0.135 0.135 0.129)",
    sand4: "color(display-p3 0.164 0.163 0.156)",
    sand5: "color(display-p3 0.193 0.192 0.183)",
    sand6: "color(display-p3 0.23 0.229 0.217)",
    sand7: "color(display-p3 0.285 0.282 0.267)",
    sand8: "color(display-p3 0.384 0.378 0.357)",
    sand9: "color(display-p3 0.434 0.428 0.403)",
    sand10: "color(display-p3 0.487 0.481 0.456)",
    sand11: "color(display-p3 0.707 0.703 0.68)",
    sand12: "color(display-p3 0.933 0.933 0.926)",
    tomato1: "color(display-p3 0.09 0.068 0.067)",
    tomato2: "color(display-p3 0.115 0.084 0.076)",
    tomato3: "color(display-p3 0.205 0.097 0.083)",
    tomato4: "color(display-p3 0.282 0.099 0.077)",
    tomato5: "color(display-p3 0.339 0.129 0.101)",
    tomato6: "color(display-p3 0.398 0.179 0.141)",
    tomato7: "color(display-p3 0.487 0.245 0.194)",
    tomato8: "color(display-p3 0.629 0.322 0.248)",
    tomato9: "color(display-p3 0.831 0.345 0.231)",
    tomato10: "color(display-p3 0.862 0.415 0.298)",
    tomato11: "color(display-p3 1 0.585 0.455)",
    tomato12: "color(display-p3 0.959 0.833 0.802)",
    ruby1: "color(display-p3 0.093 0.068 0.074)",
    ruby2: "color(display-p3 0.113 0.083 0.089)",
    ruby3: "color(display-p3 0.208 0.088 0.117)",
    ruby4: "color(display-p3 0.279 0.092 0.147)",
    ruby5: "color(display-p3 0.337 0.12 0.18)",
    ruby6: "color(display-p3 0.401 0.166 0.223)",
    ruby7: "color(display-p3 0.495 0.224 0.281)",
    ruby8: "color(display-p3 0.652 0.295 0.359)",
    ruby9: "color(display-p3 0.83 0.323 0.408)",
    ruby10: "color(display-p3 0.857 0.392 0.455)",
    ruby11: "color(display-p3 1 0.57 0.59)",
    ruby12: "color(display-p3 0.968 0.83 0.88)",
    crimson1: "color(display-p3 0.093 0.068 0.078)",
    crimson2: "color(display-p3 0.117 0.078 0.095)",
    crimson3: "color(display-p3 0.203 0.091 0.143)",
    crimson4: "color(display-p3 0.277 0.087 0.182)",
    crimson5: "color(display-p3 0.332 0.115 0.22)",
    crimson6: "color(display-p3 0.394 0.162 0.268)",
    crimson7: "color(display-p3 0.489 0.222 0.336)",
    crimson8: "color(display-p3 0.638 0.289 0.429)",
    crimson9: "color(display-p3 0.843 0.298 0.507)",
    crimson10: "color(display-p3 0.864 0.364 0.539)",
    crimson11: "color(display-p3 1 0.56 0.66)",
    crimson12: "color(display-p3 0.966 0.834 0.906)",
    plum1: "color(display-p3 0.09 0.068 0.092)",
    plum2: "color(display-p3 0.118 0.077 0.121)",
    plum3: "color(display-p3 0.192 0.105 0.202)",
    plum4: "color(display-p3 0.25 0.121 0.271)",
    plum5: "color(display-p3 0.293 0.152 0.319)",
    plum6: "color(display-p3 0.343 0.198 0.372)",
    plum7: "color(display-p3 0.424 0.262 0.461)",
    plum8: "color(display-p3 0.54 0.341 0.595)",
    plum9: "color(display-p3 0.624 0.313 0.708)",
    plum10: "color(display-p3 0.666 0.365 0.748)",
    plum11: "color(display-p3 0.86 0.602 0.933)",
    plum12: "color(display-p3 0.936 0.836 0.949)",
    violet1: "color(display-p3 0.077 0.071 0.118)",
    violet2: "color(display-p3 0.101 0.084 0.141)",
    violet3: "color(display-p3 0.154 0.123 0.256)",
    violet4: "color(display-p3 0.191 0.148 0.345)",
    violet5: "color(display-p3 0.226 0.182 0.396)",
    violet6: "color(display-p3 0.269 0.223 0.449)",
    violet7: "color(display-p3 0.326 0.277 0.53)",
    violet8: "color(display-p3 0.399 0.346 0.656)",
    violet9: "color(display-p3 0.417 0.341 0.784)",
    violet10: "color(display-p3 0.477 0.402 0.823)",
    violet11: "color(display-p3 0.72 0.65 1)",
    violet12: "color(display-p3 0.883 0.867 0.986)",
    iris1: "color(display-p3 0.075 0.075 0.114)",
    iris2: "color(display-p3 0.089 0.086 0.14)",
    iris3: "color(display-p3 0.128 0.134 0.272)",
    iris4: "color(display-p3 0.153 0.165 0.382)",
    iris5: "color(display-p3 0.192 0.201 0.44)",
    iris6: "color(display-p3 0.239 0.241 0.491)",
    iris7: "color(display-p3 0.291 0.289 0.565)",
    iris8: "color(display-p3 0.35 0.345 0.673)",
    iris9: "color(display-p3 0.357 0.357 0.81)",
    iris10: "color(display-p3 0.428 0.416 0.843)",
    iris11: "color(display-p3 0.685 0.662 1)",
    iris12: "color(display-p3 0.878 0.875 0.986)",
    cyan1: "color(display-p3 0.053 0.085 0.098)",
    cyan2: "color(display-p3 0.072 0.105 0.122)",
    cyan3: "color(display-p3 0.073 0.168 0.209)",
    cyan4: "color(display-p3 0.063 0.216 0.277)",
    cyan5: "color(display-p3 0.091 0.267 0.336)",
    cyan6: "color(display-p3 0.137 0.324 0.4)",
    cyan7: "color(display-p3 0.186 0.398 0.484)",
    cyan8: "color(display-p3 0.23 0.496 0.6)",
    cyan9: "color(display-p3 0.282 0.627 0.765)",
    cyan10: "color(display-p3 0.331 0.675 0.801)",
    cyan11: "color(display-p3 0.446 0.79 0.887)",
    cyan12: "color(display-p3 0.757 0.919 0.962)",
    jade1: "color(display-p3 0.059 0.083 0.071)",
    jade2: "color(display-p3 0.078 0.11 0.094)",
    jade3: "color(display-p3 0.091 0.176 0.138)",
    jade4: "color(display-p3 0.102 0.228 0.177)",
    jade5: "color(display-p3 0.133 0.279 0.221)",
    jade6: "color(display-p3 0.174 0.334 0.273)",
    jade7: "color(display-p3 0.219 0.402 0.335)",
    jade8: "color(display-p3 0.263 0.488 0.411)",
    jade9: "color(display-p3 0.319 0.63 0.521)",
    jade10: "color(display-p3 0.338 0.68 0.555)",
    jade11: "color(display-p3 0.4 0.835 0.656)",
    jade12: "color(display-p3 0.734 0.934 0.838)",
    grass1: "color(display-p3 0.062 0.083 0.067)",
    grass2: "color(display-p3 0.083 0.103 0.085)",
    grass3: "color(display-p3 0.118 0.163 0.122)",
    grass4: "color(display-p3 0.142 0.225 0.15)",
    grass5: "color(display-p3 0.178 0.279 0.186)",
    grass6: "color(display-p3 0.217 0.337 0.224)",
    grass7: "color(display-p3 0.258 0.4 0.264)",
    grass8: "color(display-p3 0.302 0.47 0.305)",
    grass9: "color(display-p3 0.38 0.647 0.378)",
    grass10: "color(display-p3 0.426 0.694 0.426)",
    grass11: "color(display-p3 0.535 0.807 0.542)",
    grass12: "color(display-p3 0.797 0.936 0.776)",
    mint1: "color(display-p3 0.059 0.082 0.081)",
    mint2: "color(display-p3 0.068 0.104 0.105)",
    mint3: "color(display-p3 0.077 0.17 0.168)",
    mint4: "color(display-p3 0.068 0.224 0.22)",
    mint5: "color(display-p3 0.104 0.275 0.264)",
    mint6: "color(display-p3 0.154 0.332 0.313)",
    mint7: "color(display-p3 0.207 0.403 0.373)",
    mint8: "color(display-p3 0.258 0.49 0.441)",
    mint9: "color(display-p3 0.62 0.908 0.834)",
    mint10: "color(display-p3 0.725 0.954 0.898)",
    mint11: "color(display-p3 0.482 0.825 0.733)",
    mint12: "color(display-p3 0.807 0.955 0.887)",
    lime1: "color(display-p3 0.067 0.073 0.048)",
    lime2: "color(display-p3 0.086 0.1 0.067)",
    lime3: "color(display-p3 0.13 0.16 0.099)",
    lime4: "color(display-p3 0.172 0.214 0.126)",
    lime5: "color(display-p3 0.213 0.266 0.153)",
    lime6: "color(display-p3 0.257 0.321 0.182)",
    lime7: "color(display-p3 0.307 0.383 0.215)",
    lime8: "color(display-p3 0.365 0.456 0.25)",
    lime9: "color(display-p3 0.78 0.928 0.466)",
    lime10: "color(display-p3 0.865 0.995 0.519)",
    lime11: "color(display-p3 0.771 0.893 0.485)",
    lime12: "color(display-p3 0.905 0.966 0.753)",
    bronze1: "color(display-p3 0.076 0.067 0.063)",
    bronze2: "color(display-p3 0.106 0.097 0.093)",
    bronze3: "color(display-p3 0.147 0.132 0.125)",
    bronze4: "color(display-p3 0.185 0.166 0.156)",
    bronze5: "color(display-p3 0.227 0.202 0.19)",
    bronze6: "color(display-p3 0.278 0.246 0.23)",
    bronze7: "color(display-p3 0.343 0.302 0.281)",
    bronze8: "color(display-p3 0.426 0.374 0.347)",
    bronze9: "color(display-p3 0.611 0.507 0.455)",
    bronze10: "color(display-p3 0.66 0.556 0.504)",
    bronze11: "color(display-p3 0.81 0.707 0.655)",
    bronze12: "color(display-p3 0.921 0.88 0.854)",
    gold1: "color(display-p3 0.071 0.071 0.067)",
    gold2: "color(display-p3 0.104 0.101 0.09)",
    gold3: "color(display-p3 0.141 0.136 0.122)",
    gold4: "color(display-p3 0.177 0.17 0.152)",
    gold5: "color(display-p3 0.217 0.207 0.185)",
    gold6: "color(display-p3 0.265 0.252 0.225)",
    gold7: "color(display-p3 0.327 0.31 0.277)",
    gold8: "color(display-p3 0.407 0.384 0.342)",
    gold9: "color(display-p3 0.579 0.517 0.41)",
    gold10: "color(display-p3 0.628 0.566 0.463)",
    gold11: "color(display-p3 0.784 0.728 0.635)",
    gold12: "color(display-p3 0.906 0.887 0.855)",
    brown1: "color(display-p3 0.071 0.067 0.059)",
    brown2: "color(display-p3 0.107 0.095 0.087)",
    brown3: "color(display-p3 0.151 0.13 0.115)",
    brown4: "color(display-p3 0.191 0.161 0.138)",
    brown5: "color(display-p3 0.235 0.194 0.162)",
    brown6: "color(display-p3 0.291 0.237 0.192)",
    brown7: "color(display-p3 0.365 0.295 0.232)",
    brown8: "color(display-p3 0.469 0.377 0.287)",
    brown9: "color(display-p3 0.651 0.505 0.368)",
    brown10: "color(display-p3 0.697 0.557 0.423)",
    brown11: "color(display-p3 0.835 0.715 0.597)",
    brown12: "color(display-p3 0.938 0.885 0.802)",
    amber1: "color(display-p3 0.082 0.07 0.05)",
    amber2: "color(display-p3 0.111 0.094 0.064)",
    amber3: "color(display-p3 0.178 0.128 0.049)",
    amber4: "color(display-p3 0.239 0.156 0)",
    amber5: "color(display-p3 0.29 0.193 0)",
    amber6: "color(display-p3 0.344 0.245 0.076)",
    amber7: "color(display-p3 0.422 0.314 0.141)",
    amber8: "color(display-p3 0.535 0.399 0.189)",
    amber9: "color(display-p3 1 0.77 0.26)",
    amber10: "color(display-p3 1 0.87 0.15)",
    amber11: "color(display-p3 1 0.8 0.29)",
    amber12: "color(display-p3 0.984 0.909 0.726)",
    transparent: {
      green1: "#00de4505",
      green2: "#29f99d0b",
      green3: "#22ff991e",
      green4: "#11ff992d",
      green5: "#2bffa23c",
      green6: "#44ffaa4b",
      green7: "#50fdac5e",
      green8: "#54ffad73",
      green9: "#44ffa49e",
      green10: "#43fea4ab",
      green11: "#46fea5d4",
      green12: "#bbffd7f0",
      turquoise1: "#00deab05",
      turquoise2: "#12fbe60c",
      turquoise3: "#00ffe61e",
      turquoise4: "#00ffe92d",
      turquoise5: "#00ffea3b",
      turquoise6: "#1cffe84b",
      turquoise7: "#2efde85f",
      turquoise8: "#32ffe775",
      turquoise9: "#13ffe49f",
      turquoise10: "#0dffe0ae",
      turquoise11: "#0afed5d6",
      turquoise12: "#b8ffebef",
      sky1: "#0044ff0f",
      sky2: "#1171fb18",
      sky3: "#1184fc33",
      sky4: "#128fff49",
      sky5: "#1c9dfd5d",
      sky6: "#28a5ff72",
      sky7: "#2badfe8b",
      sky8: "#1db2fea9",
      sky9: "#7ce3fffe",
      sky10: "#a8eeff",
      sky11: "#7cd3ffef",
      sky12: "#c2f3ff",
      blue1: "#1133ff0f",
      blue2: "#3354fa17",
      blue3: "#2f62ff3c",
      blue4: "#3566ff57",
      blue5: "#4171fd6b",
      blue6: "#5178fd7c",
      blue7: "#5a7fff90",
      blue8: "#5b81feac",
      blue9: "#4671ffdb",
      blue10: "#5c7efee3",
      blue11: "#9eb1ff",
      blue12: "#d6e1ff",
      purple1: "#b412f90b",
      purple2: "#b744f714",
      purple3: "#c150ff2d",
      purple4: "#bb53fd42",
      purple5: "#be5cfd51",
      purple6: "#c16dfd61",
      purple7: "#c378fd7a",
      purple8: "#c47effa4",
      purple9: "#b661ffc2",
      purple10: "#bc6fffcd",
      purple11: "#d19dff",
      purple12: "#f1ddfffa",
      pink1: "#f412bc09",
      pink2: "#f420bb12",
      pink3: "#fe37cc29",
      pink4: "#fc1ec43f",
      pink5: "#fd35c24e",
      pink6: "#fd51c75f",
      pink7: "#fd62c87b",
      pink8: "#ff68c8a2",
      pink9: "#fe49bcd4",
      pink10: "#ff5cc0dc",
      pink11: "#ff8dcc",
      pink12: "#ffd3ecfd",
      red1: "#f4121209",
      red2: "#f22f3e11",
      red3: "#ff173f2d",
      red4: "#fe0a3b44",
      red5: "#ff204756",
      red6: "#ff3e5668",
      red7: "#ff536184",
      red8: "#ff5d61b0",
      red9: "#fe4e54e4",
      red10: "#ff6465eb",
      red11: "#ff9592",
      red12: "#ffd1d9",
      orange1: "#ec360007",
      orange2: "#fe6d000e",
      orange3: "#fb6a0025",
      orange4: "#ff590039",
      orange5: "#ff61004a",
      orange6: "#fd75045c",
      orange7: "#ff832c75",
      orange8: "#fe84389d",
      orange9: "#fe6d15f7",
      orange10: "#ff801f",
      orange11: "#ffa057",
      orange12: "#ffe0c2",
      yellow1: "#d1510004",
      yellow2: "#f9b4000b",
      yellow3: "#ffaa001e",
      yellow4: "#fdb70028",
      yellow5: "#febb0036",
      yellow6: "#fec40046",
      yellow7: "#fdcb225c",
      yellow8: "#fdca327b",
      yellow9: "#ffe629",
      yellow10: "#ffff57",
      yellow11: "#fee949f5",
      yellow12: "#fef6baf6",
      gray1: "color(display-p3 1 1 1 / 0.031)",
      gray2: "color(display-p3 1 1 1 / 0.059)",
      gray3: "color(display-p3 1 1 1 / 0.047)",
      gray4: "color(display-p3 1 1 1 / 0.071)",
      gray5: "color(display-p3 1 1 1 / 0.102)",
      gray6: "color(display-p3 1 1 1 / 0.114)",
      gray7: "color(display-p3 1 1 1 / 0.141)",
      gray8: "color(display-p3 1 1 1 / 0.22)",
      gray9: "color(display-p3 1 1 1 / 0.427)",
      gray10: "color(display-p3 1 1 1 / 0.478)",
      gray11: "color(display-p3 1 1 1 / 0.565)",
      gray12: "color(display-p3 1 1 1 / 0.91)",
      mauve1: "#00000000",
      mauve2: "#f5f4f609",
      mauve3: "#ebeaf814",
      mauve4: "#eee5f81d",
      mauve5: "#efe6fe25",
      mauve6: "#f1e6fd30",
      mauve7: "#eee9ff40",
      mauve8: "#eee7ff5d",
      mauve9: "#eae6fd6e",
      mauve10: "#ece9fd7c",
      mauve11: "#f5f1ffb7",
      mauve12: "#fdfdffef",
      slate1: "#00000000",
      slate2: "#d8f4f609",
      slate3: "#ddeaf814",
      slate4: "#d3edf81d",
      slate5: "#d9edfe25",
      slate6: "#d6ebfd30",
      slate7: "#d9edff40",
      slate8: "#d9edff5d",
      slate9: "#dfebfd6d",
      slate10: "#e5edfd7b",
      slate11: "#f1f7feb5",
      slate12: "#fcfdffef",
      sage1: "#00000000",
      sage2: "#f0f2f108",
      sage3: "#f3f5f412",
      sage4: "#f2fefd1a",
      sage5: "#f1fbfa22",
      sage6: "#edfbf42d",
      sage7: "#edfcf73c",
      sage8: "#ebfdf657",
      sage9: "#dffdf266",
      sage10: "#e5fdf674",
      sage11: "#f4fefbb0",
      sage12: "#fdfffeed",
      olive1: "#00000000",
      olive2: "#f1f2f008",
      olive3: "#f4f5f312",
      olive4: "#f3fef21a",
      olive5: "#f2fbf122",
      olive6: "#f4faed2c",
      olive7: "#f2fced3b",
      olive8: "#edfdeb57",
      olive9: "#ebfde766",
      olive10: "#f0fdec74",
      olive11: "#f6fef4b0",
      olive12: "#fdfffded",
      sand1: "#00000000",
      sand2: "#f4f4f309",
      sand3: "#f6f6f513",
      sand4: "#fefef31b",
      sand5: "#fbfbeb23",
      sand6: "#fffaed2d",
      sand7: "#fffbed3c",
      sand8: "#fff9eb57",
      sand9: "#fffae965",
      sand10: "#fffdee73",
      sand11: "#fffcf4b0",
      sand12: "#fffffded",
      tomato1: "#f1121208",
      tomato2: "#ff55330f",
      tomato3: "#ff35232b",
      tomato4: "#fd201142",
      tomato5: "#fe332153",
      tomato6: "#ff4f3864",
      tomato7: "#fd644a7d",
      tomato8: "#fe6d4ea7",
      tomato9: "#fe5431e4",
      tomato10: "#ff6847eb",
      tomato11: "#ff977d",
      tomato12: "#ffd6cefb",
      ruby1: "#f4124a09",
      ruby2: "#fe5a7f0e",
      ruby3: "#ff235d2c",
      ruby4: "#fd195e42",
      ruby5: "#fe2d6b53",
      ruby6: "#ff447665",
      ruby7: "#ff577d80",
      ruby8: "#ff5c7cae",
      ruby9: "#fe4c70e4",
      ruby10: "#ff617beb",
      ruby11: "#ff949d",
      ruby12: "#ffd3e2fe",
      crimson1: "#f4126709",
      crimson2: "#f22f7a11",
      crimson3: "#fe2a8b2a",
      crimson4: "#fd158741",
      crimson5: "#fd278f51",
      crimson6: "#fe459763",
      crimson7: "#fd559b7f",
      crimson8: "#fe5b9bab",
      crimson9: "#fe418de8",
      crimson10: "#ff5693ed",
      crimson11: "#ff92ad",
      crimson12: "#ffd5eafd",
      plum1: "#f112f108",
      plum2: "#f22ff211",
      plum3: "#fd4cfd27",
      plum4: "#f646ff3a",
      plum5: "#f455ff48",
      plum6: "#f66dff56",
      plum7: "#f07cfd70",
      plum8: "#ee84ff95",
      plum9: "#e961feb6",
      plum10: "#ed70ffc0",
      plum11: "#f19cfef3",
      plum12: "#feddfef4",
      violet1: "#4422ff0f",
      violet2: "#853ff916",
      violet3: "#8354fe36",
      violet4: "#7d51fd50",
      violet5: "#845ffd5f",
      violet6: "#8f6cfd6d",
      violet7: "#9879ff83",
      violet8: "#977dfea8",
      violet9: "#8668ffcc",
      violet10: "#9176fed7",
      violet11: "#baa7ff",
      violet12: "#e3defffe",
      iris1: "#3636fe0e",
      iris2: "#564bf916",
      iris3: "#525bff3b",
      iris4: "#4d58ff5a",
      iris5: "#5b62fd6b",
      iris6: "#6d6ffd7a",
      iris7: "#7777fe8e",
      iris8: "#7b7afeac",
      iris9: "#6a6afed4",
      iris10: "#7d79ffdc",
      iris11: "#b1a9ff",
      iris12: "#e1e0fffe",
      cyan1: "#0091f70a",
      cyan2: "#02a7f211",
      cyan3: "#00befd28",
      cyan4: "#00baff3b",
      cyan5: "#00befd4d",
      cyan6: "#00c7fd5e",
      cyan7: "#14cdff75",
      cyan8: "#11cfff95",
      cyan9: "#00cfffc3",
      cyan10: "#28d6ffcd",
      cyan11: "#52e1fee5",
      cyan12: "#bbf3fef7",
      jade1: "#00de4505",
      jade2: "#27fba60c",
      jade3: "#02f99920",
      jade4: "#00ffaa2d",
      jade5: "#11ffb63b",
      jade6: "#34ffc24b",
      jade7: "#45fdc75e",
      jade8: "#48ffcf75",
      jade9: "#38feca9d",
      jade10: "#31fec7ab",
      jade11: "#21fec0d6",
      jade12: "#b8ffe1ef",
      grass1: "#00de1205",
      grass2: "#5ef7780a",
      grass3: "#70fe8c1b",
      grass4: "#57ff802c",
      grass5: "#68ff8b3b",
      grass6: "#71ff8f4b",
      grass7: "#77fd925d",
      grass8: "#77fd9070",
      grass9: "#65ff82a1",
      grass10: "#72ff8dae",
      grass11: "#89ff9fcd",
      grass12: "#ceffceef",
      mint1: "#00dede05",
      mint2: "#00f9f90b",
      mint3: "#00fff61d",
      mint4: "#00fff42c",
      mint5: "#00fff23a",
      mint6: "#0effeb4a",
      mint7: "#34fde55e",
      mint8: "#41ffdf76",
      mint9: "#92ffe7e9",
      mint10: "#aefeedf5",
      mint11: "#67ffded2",
      mint12: "#cbfee9f5",
      lime1: "#11bb0003",
      lime2: "#78f7000a",
      lime3: "#9bfd4c1a",
      lime4: "#a7fe5c29",
      lime5: "#affe6537",
      lime6: "#b2fe6d46",
      lime7: "#b6ff6f57",
      lime8: "#b6fd6d6c",
      lime9: "#caff69ed",
      lime10: "#d4ff70",
      lime11: "#d1fe77e4",
      lime12: "#e9febff7",
      bronze1: "#d1110004",
      bronze2: "#fbbc910c",
      bronze3: "#faceb817",
      bronze4: "#facdb622",
      bronze5: "#ffd2c12d",
      bronze6: "#ffd1c03c",
      bronze7: "#fdd0c04f",
      bronze8: "#ffd6c565",
      bronze9: "#fec7b09b",
      bronze10: "#fecab5a9",
      bronze11: "#ffd7c6d1",
      bronze12: "#fff1e9ec",
      gold1: "#91911102",
      gold2: "#f9e29d0b",
      gold3: "#f8ecbb15",
      gold4: "#ffeec41e",
      gold5: "#feecc22a",
      gold6: "#feebcb37",
      gold7: "#ffedcd48",
      gold8: "#fdeaca5f",
      gold9: "#ffdba690",
      gold10: "#fedfb09d",
      gold11: "#fee7c6c8",
      gold12: "#fef7ede7",
      brown1: "#91110002",
      brown2: "#fba67c0c",
      brown3: "#fcb58c19",
      brown4: "#fbbb8a24",
      brown5: "#fcb88931",
      brown6: "#fdba8741",
      brown7: "#ffbb8856",
      brown8: "#ffbe8773",
      brown9: "#feb87da8",
      brown10: "#ffc18cb3",
      brown11: "#fed1aad9",
      brown12: "#feecd4f2",
      amber1: "#e63c0006",
      amber2: "#fd9b000d",
      amber3: "#fa820022",
      amber4: "#fc820032",
      amber5: "#fd8b0041",
      amber6: "#fd9b0051",
      amber7: "#ffab2567",
      amber8: "#ffae3587",
      amber9: "#ffc53d",
      amber10: "#ffd60a",
      amber11: "#ffca16",
      amber12: "#ffe7b3"
    }
  }
}, lr = {
  icon: {
    size: {
      sm: 14,
      md: 16,
      lg: 20,
      xl: 24
    },
    stroke: {
      sm: 1.6,
      md: 2,
      lg: 2.5
    }
  },
  modal: { size: {
    sm: { width: "300px" },
    md: { width: "400px" },
    lg: { width: "53%" },
    xl: {
      width: "1200px",
      height: "800px"
    },
    fullscreen: {
      width: "calc(100dvw / var(--t-zoom, 1))",
      height: "calc(100dvh / var(--t-zoom, 1))"
    }
  } },
  text: {
    lineHeight: {
      lg: 1.5,
      md: 1.1
    },
    iconSizeMedium: 16,
    iconSizeSmall: 14,
    iconStrikeLight: 1.6,
    iconStrikeMedium: 2,
    iconStrikeBold: 2.5
  },
  tooltip: {
    background: "color(display-p3 0 0 0 / 0.72)",
    color: "color(display-p3 1 1 1 / 1)",
    descriptionColor: "color(display-p3 1 1 1 / 0.64)"
  },
  animation: { duration: {
    instant: 0.075,
    fast: 0.15,
    normal: 0.3,
    slow: 1.5
  } },
  spacingMultiplicator: 4,
  spacing: m,
  betweenSiblingsGap: "2px",
  table: {
    horizontalCellMargin: "8px",
    checkboxColumnWidth: "32px",
    horizontalCellPadding: "8px"
  },
  sidePanelWidth: "500px",
  clickableElementBackgroundTransition: "background 0.1s ease",
  lastLayerZIndex: 2147483647,
  buttons: { secondaryTextColor: "color(display-p3 0.63 0.69 1)" },
  accent: {
    primary: "color(display-p3 0.831 0.87 1)",
    secondary: "color(display-p3 0.831 0.87 1)",
    tertiary: "color(display-p3 0.933 0.948 0.992)",
    quaternary: "color(display-p3 0.971 0.977 0.998)",
    accent3570: "color(display-p3 0.569 0.639 0.916)",
    accent4060: "color(display-p3 0.569 0.639 0.916)",
    accent1: "color(display-p3 0.992 0.992 0.996)",
    accent2: "color(display-p3 0.971 0.977 0.998)",
    accent3: "color(display-p3 0.933 0.948 0.992)",
    accent4: "color(display-p3 0.885 0.914 1)",
    accent5: "color(display-p3 0.831 0.87 1)",
    accent6: "color(display-p3 0.767 0.814 0.995)",
    accent7: "color(display-p3 0.685 0.74 0.957)",
    accent8: "color(display-p3 0.569 0.639 0.916)",
    accent9: "color(display-p3 0.276 0.384 0.837)",
    accent10: "color(display-p3 0.234 0.343 0.801)",
    accent11: "color(display-p3 0.256 0.354 0.755)",
    accent12: "color(display-p3 0.133 0.175 0.348)"
  },
  background: {
    noisy: "var(--t-background-noisy)",
    primary: "color(display-p3 1 1 1)",
    secondary: "color(display-p3 0.988 0.988 0.988)",
    tertiary: "color(display-p3 0.945 0.945 0.945)",
    quaternary: "color(display-p3 0.922 0.922 0.922)",
    invertedPrimary: "color(display-p3 0.2 0.2 0.2)",
    invertedSecondary: "color(display-p3 0.4 0.4 0.4)",
    danger: "color(display-p3 0.985 0.925 0.925)",
    transparent: {
      primary: "color(display-p3 1 1 1 / 0.5)",
      secondary: "color(display-p3 1 1 1 / 0.4)",
      strong: "color(display-p3 0 0 0 / 0.161)",
      medium: "color(display-p3 0 0 0 / 0.078)",
      light: "color(display-p3 0 0 0 / 0.039)",
      lighter: "color(display-p3 0 0 0 / 0.02)",
      danger: "#f3000d14",
      blue: "#0047f112",
      orange: "#ff9c0029",
      success: "#00a43319"
    },
    overlayPrimary: "color(display-p3 0 0 0 / 0.722)",
    overlaySecondary: "color(display-p3 0 0 0 / 0.361)",
    overlayTertiary: "color(display-p3 0 0 0 / 0.071)",
    radialGradient: "radial-gradient(50% 62.62% at 50% 0%, color(display-p3 0.6 0.6 0.6) 0%, color(display-p3 0.514 0.514 0.514) 100%)",
    radialGradientHover: "radial-gradient(76.32% 95.59% at 50% 0%, color(display-p3 0.514 0.514 0.514) 0%, color(display-p3 0.4 0.4 0.4) 100%)",
    primaryInverted: "color(display-p3 0.2 0.2 0.2)",
    primaryInvertedHover: "color(display-p3 0.4 0.4 0.4)"
  },
  blur: {
    light: "blur(6px) saturate(200%) contrast(50%) brightness(130%)",
    medium: "blur(12px) saturate(200%) contrast(50%) brightness(130%)",
    strong: "blur(20px) saturate(200%) contrast(50%) brightness(130%)"
  },
  border: {
    color: {
      strong: "color(display-p3 0.839 0.839 0.839)",
      medium: "color(display-p3 0.922 0.922 0.922)",
      light: "color(display-p3 0.945 0.945 0.945)",
      secondaryInverted: "color(display-p3 0.4 0.4 0.4)",
      inverted: "color(display-p3 0.2 0.2 0.2)",
      danger: "color(display-p3 0.984 0.812 0.811)",
      blue: "color(display-p3 0.685 0.74 0.957)",
      transparentStrong: "color(display-p3 0 0 0 / 0.071)"
    },
    radius: {
      xs: "2px",
      sm: "4px",
      md: "8px",
      smRound: "4px",
      mdRound: "8px",
      lg: "16px",
      xl: "20px",
      xxl: "40px",
      pill: "999px",
      rounded: "100%"
    }
  },
  boxShadow: {
    color: "color(display-p3 0 0 0 / 0.039)",
    light: "0px 2px 4px 0px color(display-p3 0 0 0 / 0.039), 0px 0px 4px 0px color(display-p3 0 0 0 / 0.078)",
    sidebar: "-4px 4px 4px 0px rgba(0, 0, 0, 0.005)",
    strong: "2px 4px 16px 0px color(display-p3 0 0 0 / 0.161), 0px 2px 4px 0px color(display-p3 0 0 0 / 0.078)",
    underline: "0px 1px 0px 0px color(display-p3 0 0 0 / 0.361)",
    superHeavy: "0px 0px 8px 0px color(display-p3 0 0 0 / 0.161), 0px 8px 64px -16px color(display-p3 0 0 0 / 0.478), 0px 24px 56px -16px color(display-p3 0 0 0 / 0.078)"
  },
  font: {
    color: {
      primary: "color(display-p3 0.2 0.2 0.2)",
      secondary: "color(display-p3 0.4 0.4 0.4)",
      tertiary: "color(display-p3 0.6 0.6 0.6)",
      light: "color(display-p3 0.702 0.702 0.702)",
      extraLight: "color(display-p3 0.8 0.8 0.8)",
      inverted: "color(display-p3 1 1 1)",
      onAccent: "color(display-p3 1 1 1)",
      danger: "color(display-p3 0.83 0.329 0.324)"
    },
    size: {
      xxs: "0.625rem",
      xs: "0.85rem",
      sm: "0.92rem",
      md: "1rem",
      lg: "1.23rem",
      xl: "1.54rem",
      xxl: "1.85rem"
    },
    weight: {
      regular: 400,
      medium: 500,
      semiBold: 600
    },
    family: "Inter, sans-serif"
  },
  name: "light",
  snackBar: {
    success: {
      color: "color(display-p3 0.297 0.637 0.581)",
      backgroundColor: "#00a43319"
    },
    error: {
      color: "color(display-p3 0.83 0.329 0.324)",
      backgroundColor: "#f3000d14"
    },
    warning: {
      color: "color(display-p3 0.9 0.45 0.2)",
      backgroundColor: "#ff9c0029"
    },
    info: {
      color: "color(display-p3 0.276 0.384 0.837)",
      backgroundColor: "#0047f112"
    },
    default: {
      color: "color(display-p3 0.2 0.2 0.2)",
      backgroundColor: "color(display-p3 0 0 0 / 0.039)"
    }
  },
  tag: {
    text: {
      gray: "color(display-p3 0.4 0.4 0.4)",
      mauve: "color(display-p3 0.395 0.388 0.424)",
      slate: "color(display-p3 0.379 0.392 0.421)",
      sage: "color(display-p3 0.377 0.395 0.389)",
      olive: "color(display-p3 0.38 0.395 0.374)",
      sand: "color(display-p3 0.388 0.388 0.37)",
      tomato: "color(display-p3 0.755 0.259 0.152)",
      red: "color(display-p3 0.744 0.234 0.222)",
      ruby: "color(display-p3 0.728 0.211 0.311)",
      crimson: "color(display-p3 0.731 0.195 0.388)",
      pink: "color(display-p3 0.698 0.219 0.528)",
      plum: "color(display-p3 0.543 0.263 0.619)",
      purple: "color(display-p3 0.473 0.281 0.687)",
      violet: "color(display-p3 0.383 0.317 0.702)",
      iris: "color(display-p3 0.337 0.326 0.748)",
      cyan: "color(display-p3 0.08 0.48 0.63)",
      turquoise: "color(display-p3 0.08 0.5 0.43)",
      sky: "color(display-p3 0.193 0.448 0.605)",
      blue: "color(display-p3 0.256 0.354 0.755)",
      jade: "color(display-p3 0.15 0.5 0.37)",
      green: "color(display-p3 0.19 0.5 0.32)",
      grass: "color(display-p3 0.263 0.488 0.261)",
      mint: "color(display-p3 0.203 0.463 0.397)",
      lime: "color(display-p3 0.386 0.482 0.227)",
      bronze: "color(display-p3 0.471 0.373 0.336)",
      gold: "color(display-p3 0.433 0.386 0.305)",
      brown: "color(display-p3 0.485 0.374 0.288)",
      orange: "color(display-p3 0.76 0.34 0)",
      amber: "color(display-p3 0.64 0.4 0)",
      yellow: "color(display-p3 0.6 0.44 0)"
    },
    background: {
      gray: "color(display-p3 0.976 0.976 0.976)",
      mauve: "color(display-p3 0.946 0.938 0.952)",
      slate: "color(display-p3 0.94 0.941 0.953)",
      sage: "color(display-p3 0.935 0.944 0.94)",
      olive: "color(display-p3 0.939 0.945 0.937)",
      sand: "color(display-p3 0.943 0.942 0.936)",
      tomato: "color(display-p3 0.985 0.924 0.909)",
      red: "color(display-p3 0.985 0.925 0.925)",
      ruby: "color(display-p3 0.983 0.92 0.928)",
      crimson: "color(display-p3 0.987 0.917 0.941)",
      pink: "color(display-p3 0.981 0.917 0.96)",
      plum: "color(display-p3 0.973 0.923 0.98)",
      purple: "color(display-p3 0.963 0.931 0.989)",
      violet: "color(display-p3 0.953 0.943 0.993)",
      iris: "color(display-p3 0.943 0.945 0.992)",
      cyan: "color(display-p3 0.888 0.965 0.975)",
      turquoise: "color(display-p3 0.895 0.971 0.952)",
      sky: "color(display-p3 0.899 0.963 0.989)",
      blue: "color(display-p3 0.933 0.948 0.992)",
      jade: "color(display-p3 0.912 0.965 0.932)",
      green: "color(display-p3 0.913 0.964 0.925)",
      grass: "color(display-p3 0.923 0.965 0.917)",
      mint: "color(display-p3 0.888 0.972 0.95)",
      lime: "color(display-p3 0.939 0.965 0.851)",
      bronze: "color(display-p3 0.958 0.932 0.919)",
      gold: "color(display-p3 0.947 0.94 0.909)",
      brown: "color(display-p3 0.959 0.936 0.909)",
      orange: "color(display-p3 0.989 0.938 0.85)",
      amber: "color(display-p3 0.994 0.969 0.782)",
      yellow: "color(display-p3 0.997 0.982 0.749)"
    }
  },
  code: {
    text: {
      gray: "color(display-p3 0.514 0.514 0.514)",
      sky: "color(display-p3 0.555 0.845 0.959)",
      pink: "color(display-p3 0.748 0.27 0.581)",
      orange: "color(display-p3 0.877 0.597 0.379)",
      green: "color(display-p3 0.585 0.707 0.378)"
    },
    font: { family: "DM Mono" }
  },
  IllustrationIcon: {
    color: {
      blue: "color(display-p3 0.569 0.639 0.916)",
      gray: "color(display-p3 0.6 0.6 0.6)"
    },
    fill: {
      blue: "color(display-p3 0.831 0.87 1)",
      gray: "color(display-p3 0.922 0.922 0.922)"
    }
  },
  grayScale: {
    gray1: "color(display-p3 1 1 1)",
    gray2: "color(display-p3 0.988 0.988 0.988)",
    gray3: "color(display-p3 0.976 0.976 0.976)",
    gray4: "color(display-p3 0.945 0.945 0.945)",
    gray5: "color(display-p3 0.922 0.922 0.922)",
    gray6: "color(display-p3 0.839 0.839 0.839)",
    gray7: "color(display-p3 0.8 0.8 0.8)",
    gray8: "color(display-p3 0.702 0.702 0.702)",
    gray9: "color(display-p3 0.6 0.6 0.6)",
    gray10: "color(display-p3 0.514 0.514 0.514)",
    gray11: "color(display-p3 0.4 0.4 0.4)",
    gray12: "color(display-p3 0.2 0.2 0.2)"
  },
  color: {
    red: "color(display-p3 0.83 0.329 0.324)",
    ruby: "color(display-p3 0.83 0.323 0.408)",
    crimson: "color(display-p3 0.843 0.298 0.507)",
    tomato: "color(display-p3 0.831 0.345 0.231)",
    orange: "color(display-p3 0.9 0.45 0.2)",
    amber: "color(display-p3 1 0.77 0.26)",
    yellow: "color(display-p3 1 0.92 0.22)",
    lime: "color(display-p3 0.78 0.928 0.466)",
    grass: "color(display-p3 0.38 0.647 0.378)",
    green: "color(display-p3 0.332 0.634 0.442)",
    jade: "color(display-p3 0.319 0.63 0.521)",
    mint: "color(display-p3 0.62 0.908 0.834)",
    turquoise: "color(display-p3 0.297 0.637 0.581)",
    cyan: "color(display-p3 0.282 0.627 0.765)",
    sky: "color(display-p3 0.585 0.877 0.983)",
    blue: "color(display-p3 0.276 0.384 0.837)",
    iris: "color(display-p3 0.357 0.357 0.81)",
    violet: "color(display-p3 0.417 0.341 0.784)",
    purple: "color(display-p3 0.523 0.318 0.751)",
    plum: "color(display-p3 0.624 0.313 0.708)",
    pink: "color(display-p3 0.775 0.297 0.61)",
    bronze: "color(display-p3 0.611 0.507 0.455)",
    gold: "color(display-p3 0.579 0.517 0.41)",
    brown: "color(display-p3 0.651 0.505 0.368)",
    gray: "color(display-p3 0.6 0.6 0.6)",
    yellow1: "color(display-p3 0.992 0.992 0.978)",
    yellow2: "color(display-p3 0.995 0.99 0.922)",
    yellow3: "color(display-p3 0.997 0.982 0.749)",
    yellow4: "color(display-p3 0.992 0.953 0.627)",
    yellow5: "color(display-p3 0.984 0.91 0.51)",
    yellow6: "color(display-p3 0.934 0.847 0.474)",
    yellow7: "color(display-p3 0.876 0.785 0.46)",
    yellow8: "color(display-p3 0.811 0.689 0.313)",
    yellow9: "color(display-p3 1 0.92 0.22)",
    yellow10: "color(display-p3 0.977 0.868 0.291)",
    yellow11: "color(display-p3 0.6 0.44 0)",
    yellow12: "color(display-p3 0.271 0.233 0.137)",
    green1: "color(display-p3 0.986 0.996 0.989)",
    green2: "color(display-p3 0.963 0.983 0.967)",
    green3: "color(display-p3 0.913 0.964 0.925)",
    green4: "color(display-p3 0.859 0.94 0.879)",
    green5: "color(display-p3 0.796 0.907 0.826)",
    green6: "color(display-p3 0.718 0.863 0.761)",
    green7: "color(display-p3 0.61 0.801 0.675)",
    green8: "color(display-p3 0.451 0.715 0.559)",
    green9: "color(display-p3 0.332 0.634 0.442)",
    green10: "color(display-p3 0.308 0.595 0.417)",
    green11: "color(display-p3 0.19 0.5 0.32)",
    green12: "color(display-p3 0.132 0.228 0.18)",
    turquoise1: "color(display-p3 0.983 0.996 0.992)",
    turquoise2: "color(display-p3 0.958 0.983 0.976)",
    turquoise3: "color(display-p3 0.895 0.971 0.952)",
    turquoise4: "color(display-p3 0.831 0.949 0.92)",
    turquoise5: "color(display-p3 0.761 0.914 0.878)",
    turquoise6: "color(display-p3 0.682 0.864 0.825)",
    turquoise7: "color(display-p3 0.581 0.798 0.756)",
    turquoise8: "color(display-p3 0.433 0.716 0.671)",
    turquoise9: "color(display-p3 0.297 0.637 0.581)",
    turquoise10: "color(display-p3 0.275 0.599 0.542)",
    turquoise11: "color(display-p3 0.08 0.5 0.43)",
    turquoise12: "color(display-p3 0.11 0.235 0.219)",
    sky1: "color(display-p3 0.98 0.995 0.999)",
    sky2: "color(display-p3 0.953 0.98 0.99)",
    sky3: "color(display-p3 0.899 0.963 0.989)",
    sky4: "color(display-p3 0.842 0.937 0.977)",
    sky5: "color(display-p3 0.777 0.9 0.954)",
    sky6: "color(display-p3 0.701 0.851 0.921)",
    sky7: "color(display-p3 0.604 0.785 0.879)",
    sky8: "color(display-p3 0.457 0.696 0.829)",
    sky9: "color(display-p3 0.585 0.877 0.983)",
    sky10: "color(display-p3 0.555 0.845 0.959)",
    sky11: "color(display-p3 0.193 0.448 0.605)",
    sky12: "color(display-p3 0.145 0.241 0.329)",
    blue1: "color(display-p3 0.992 0.992 0.996)",
    blue2: "color(display-p3 0.971 0.977 0.998)",
    blue3: "color(display-p3 0.933 0.948 0.992)",
    blue4: "color(display-p3 0.885 0.914 1)",
    blue5: "color(display-p3 0.831 0.87 1)",
    blue6: "color(display-p3 0.767 0.814 0.995)",
    blue7: "color(display-p3 0.685 0.74 0.957)",
    blue8: "color(display-p3 0.569 0.639 0.916)",
    blue9: "color(display-p3 0.276 0.384 0.837)",
    blue10: "color(display-p3 0.234 0.343 0.801)",
    blue11: "color(display-p3 0.256 0.354 0.755)",
    blue12: "color(display-p3 0.133 0.175 0.348)",
    purple1: "color(display-p3 0.995 0.988 0.996)",
    purple2: "color(display-p3 0.983 0.971 0.993)",
    purple3: "color(display-p3 0.963 0.931 0.989)",
    purple4: "color(display-p3 0.937 0.888 0.981)",
    purple5: "color(display-p3 0.904 0.837 0.966)",
    purple6: "color(display-p3 0.86 0.774 0.942)",
    purple7: "color(display-p3 0.799 0.69 0.91)",
    purple8: "color(display-p3 0.719 0.583 0.874)",
    purple9: "color(display-p3 0.523 0.318 0.751)",
    purple10: "color(display-p3 0.483 0.289 0.7)",
    purple11: "color(display-p3 0.473 0.281 0.687)",
    purple12: "color(display-p3 0.234 0.132 0.363)",
    pink1: "color(display-p3 0.998 0.989 0.996)",
    pink2: "color(display-p3 0.992 0.97 0.985)",
    pink3: "color(display-p3 0.981 0.917 0.96)",
    pink4: "color(display-p3 0.963 0.867 0.932)",
    pink5: "color(display-p3 0.939 0.815 0.899)",
    pink6: "color(display-p3 0.907 0.756 0.859)",
    pink7: "color(display-p3 0.869 0.683 0.81)",
    pink8: "color(display-p3 0.825 0.59 0.751)",
    pink9: "color(display-p3 0.775 0.297 0.61)",
    pink10: "color(display-p3 0.748 0.27 0.581)",
    pink11: "color(display-p3 0.698 0.219 0.528)",
    pink12: "color(display-p3 0.363 0.101 0.279)",
    red1: "color(display-p3 0.998 0.989 0.988)",
    red2: "color(display-p3 0.995 0.971 0.971)",
    red3: "color(display-p3 0.985 0.925 0.925)",
    red4: "color(display-p3 0.999 0.866 0.866)",
    red5: "color(display-p3 0.984 0.812 0.811)",
    red6: "color(display-p3 0.955 0.751 0.749)",
    red7: "color(display-p3 0.915 0.675 0.672)",
    red8: "color(display-p3 0.872 0.575 0.572)",
    red9: "color(display-p3 0.83 0.329 0.324)",
    red10: "color(display-p3 0.798 0.294 0.285)",
    red11: "color(display-p3 0.744 0.234 0.222)",
    red12: "color(display-p3 0.36 0.115 0.143)",
    orange1: "color(display-p3 0.995 0.988 0.985)",
    orange2: "color(display-p3 0.994 0.968 0.934)",
    orange3: "color(display-p3 0.989 0.938 0.85)",
    orange4: "color(display-p3 1 0.874 0.687)",
    orange5: "color(display-p3 1 0.821 0.583)",
    orange6: "color(display-p3 0.975 0.767 0.545)",
    orange7: "color(display-p3 0.919 0.693 0.486)",
    orange8: "color(display-p3 0.877 0.597 0.379)",
    orange9: "color(display-p3 0.9 0.45 0.2)",
    orange10: "color(display-p3 0.87 0.409 0.164)",
    orange11: "color(display-p3 0.76 0.34 0)",
    orange12: "color(display-p3 0.323 0.185 0.127)",
    gray1: "color(display-p3 1 1 1)",
    gray2: "color(display-p3 0.988 0.988 0.988)",
    gray3: "color(display-p3 0.976 0.976 0.976)",
    gray4: "color(display-p3 0.945 0.945 0.945)",
    gray5: "color(display-p3 0.922 0.922 0.922)",
    gray6: "color(display-p3 0.839 0.839 0.839)",
    gray7: "color(display-p3 0.8 0.8 0.8)",
    gray8: "color(display-p3 0.702 0.702 0.702)",
    gray9: "color(display-p3 0.6 0.6 0.6)",
    gray10: "color(display-p3 0.514 0.514 0.514)",
    gray11: "color(display-p3 0.4 0.4 0.4)",
    gray12: "color(display-p3 0.2 0.2 0.2)",
    mauve1: "color(display-p3 0.991 0.988 0.992)",
    mauve2: "color(display-p3 0.98 0.976 0.984)",
    mauve3: "color(display-p3 0.946 0.938 0.952)",
    mauve4: "color(display-p3 0.915 0.906 0.925)",
    mauve5: "color(display-p3 0.886 0.876 0.901)",
    mauve6: "color(display-p3 0.856 0.846 0.875)",
    mauve7: "color(display-p3 0.814 0.804 0.84)",
    mauve8: "color(display-p3 0.735 0.728 0.777)",
    mauve9: "color(display-p3 0.555 0.549 0.596)",
    mauve10: "color(display-p3 0.514 0.508 0.552)",
    mauve11: "color(display-p3 0.395 0.388 0.424)",
    mauve12: "color(display-p3 0.128 0.122 0.147)",
    slate1: "color(display-p3 0.988 0.988 0.992)",
    slate2: "color(display-p3 0.976 0.976 0.984)",
    slate3: "color(display-p3 0.94 0.941 0.953)",
    slate4: "color(display-p3 0.908 0.909 0.925)",
    slate5: "color(display-p3 0.88 0.881 0.901)",
    slate6: "color(display-p3 0.85 0.852 0.876)",
    slate7: "color(display-p3 0.805 0.808 0.838)",
    slate8: "color(display-p3 0.727 0.733 0.773)",
    slate9: "color(display-p3 0.547 0.553 0.592)",
    slate10: "color(display-p3 0.503 0.512 0.549)",
    slate11: "color(display-p3 0.379 0.392 0.421)",
    slate12: "color(display-p3 0.113 0.125 0.14)",
    sage1: "color(display-p3 0.986 0.992 0.988)",
    sage2: "color(display-p3 0.97 0.977 0.974)",
    sage3: "color(display-p3 0.935 0.944 0.94)",
    sage4: "color(display-p3 0.904 0.913 0.909)",
    sage5: "color(display-p3 0.875 0.885 0.88)",
    sage6: "color(display-p3 0.844 0.854 0.849)",
    sage7: "color(display-p3 0.8 0.811 0.806)",
    sage8: "color(display-p3 0.725 0.738 0.732)",
    sage9: "color(display-p3 0.531 0.556 0.546)",
    sage10: "color(display-p3 0.492 0.515 0.506)",
    sage11: "color(display-p3 0.377 0.395 0.389)",
    sage12: "color(display-p3 0.107 0.129 0.118)",
    olive1: "color(display-p3 0.989 0.992 0.989)",
    olive2: "color(display-p3 0.974 0.98 0.973)",
    olive3: "color(display-p3 0.939 0.945 0.937)",
    olive4: "color(display-p3 0.907 0.914 0.905)",
    olive5: "color(display-p3 0.878 0.885 0.875)",
    olive6: "color(display-p3 0.846 0.855 0.843)",
    olive7: "color(display-p3 0.803 0.812 0.8)",
    olive8: "color(display-p3 0.727 0.738 0.723)",
    olive9: "color(display-p3 0.541 0.556 0.532)",
    olive10: "color(display-p3 0.5 0.515 0.491)",
    olive11: "color(display-p3 0.38 0.395 0.374)",
    olive12: "color(display-p3 0.117 0.129 0.111)",
    sand1: "color(display-p3 0.992 0.992 0.989)",
    sand2: "color(display-p3 0.977 0.977 0.973)",
    sand3: "color(display-p3 0.943 0.942 0.936)",
    sand4: "color(display-p3 0.913 0.912 0.903)",
    sand5: "color(display-p3 0.885 0.883 0.873)",
    sand6: "color(display-p3 0.854 0.852 0.839)",
    sand7: "color(display-p3 0.813 0.81 0.794)",
    sand8: "color(display-p3 0.738 0.734 0.713)",
    sand9: "color(display-p3 0.553 0.553 0.528)",
    sand10: "color(display-p3 0.511 0.511 0.488)",
    sand11: "color(display-p3 0.388 0.388 0.37)",
    sand12: "color(display-p3 0.129 0.126 0.111)",
    tomato1: "color(display-p3 0.998 0.989 0.988)",
    tomato2: "color(display-p3 0.994 0.974 0.969)",
    tomato3: "color(display-p3 0.985 0.924 0.909)",
    tomato4: "color(display-p3 0.996 0.868 0.835)",
    tomato5: "color(display-p3 0.98 0.812 0.77)",
    tomato6: "color(display-p3 0.953 0.75 0.698)",
    tomato7: "color(display-p3 0.917 0.673 0.611)",
    tomato8: "color(display-p3 0.875 0.575 0.502)",
    tomato9: "color(display-p3 0.831 0.345 0.231)",
    tomato10: "color(display-p3 0.802 0.313 0.2)",
    tomato11: "color(display-p3 0.755 0.259 0.152)",
    tomato12: "color(display-p3 0.335 0.165 0.132)",
    ruby1: "color(display-p3 0.998 0.989 0.992)",
    ruby2: "color(display-p3 0.995 0.971 0.974)",
    ruby3: "color(display-p3 0.983 0.92 0.928)",
    ruby4: "color(display-p3 0.987 0.869 0.885)",
    ruby5: "color(display-p3 0.968 0.817 0.839)",
    ruby6: "color(display-p3 0.937 0.758 0.786)",
    ruby7: "color(display-p3 0.897 0.685 0.721)",
    ruby8: "color(display-p3 0.851 0.588 0.639)",
    ruby9: "color(display-p3 0.83 0.323 0.408)",
    ruby10: "color(display-p3 0.795 0.286 0.375)",
    ruby11: "color(display-p3 0.728 0.211 0.311)",
    ruby12: "color(display-p3 0.36 0.115 0.171)",
    crimson1: "color(display-p3 0.998 0.989 0.992)",
    crimson2: "color(display-p3 0.991 0.969 0.976)",
    crimson3: "color(display-p3 0.987 0.917 0.941)",
    crimson4: "color(display-p3 0.975 0.866 0.904)",
    crimson5: "color(display-p3 0.953 0.813 0.864)",
    crimson6: "color(display-p3 0.921 0.755 0.817)",
    crimson7: "color(display-p3 0.88 0.683 0.761)",
    crimson8: "color(display-p3 0.834 0.592 0.694)",
    crimson9: "color(display-p3 0.843 0.298 0.507)",
    crimson10: "color(display-p3 0.807 0.266 0.468)",
    crimson11: "color(display-p3 0.731 0.195 0.388)",
    crimson12: "color(display-p3 0.352 0.111 0.221)",
    plum1: "color(display-p3 0.995 0.988 0.999)",
    plum2: "color(display-p3 0.988 0.971 0.99)",
    plum3: "color(display-p3 0.973 0.923 0.98)",
    plum4: "color(display-p3 0.953 0.875 0.966)",
    plum5: "color(display-p3 0.926 0.825 0.945)",
    plum6: "color(display-p3 0.89 0.765 0.916)",
    plum7: "color(display-p3 0.84 0.686 0.877)",
    plum8: "color(display-p3 0.775 0.58 0.832)",
    plum9: "color(display-p3 0.624 0.313 0.708)",
    plum10: "color(display-p3 0.587 0.29 0.667)",
    plum11: "color(display-p3 0.543 0.263 0.619)",
    plum12: "color(display-p3 0.299 0.114 0.352)",
    violet1: "color(display-p3 0.991 0.988 0.995)",
    violet2: "color(display-p3 0.978 0.974 0.998)",
    violet3: "color(display-p3 0.953 0.943 0.993)",
    violet4: "color(display-p3 0.916 0.897 1)",
    violet5: "color(display-p3 0.876 0.851 1)",
    violet6: "color(display-p3 0.825 0.793 0.981)",
    violet7: "color(display-p3 0.752 0.712 0.943)",
    violet8: "color(display-p3 0.654 0.602 0.902)",
    violet9: "color(display-p3 0.417 0.341 0.784)",
    violet10: "color(display-p3 0.381 0.306 0.741)",
    violet11: "color(display-p3 0.383 0.317 0.702)",
    violet12: "color(display-p3 0.179 0.15 0.359)",
    iris1: "color(display-p3 0.992 0.992 0.999)",
    iris2: "color(display-p3 0.972 0.973 0.998)",
    iris3: "color(display-p3 0.943 0.945 0.992)",
    iris4: "color(display-p3 0.902 0.906 1)",
    iris5: "color(display-p3 0.857 0.861 1)",
    iris6: "color(display-p3 0.799 0.805 0.987)",
    iris7: "color(display-p3 0.721 0.727 0.955)",
    iris8: "color(display-p3 0.61 0.619 0.918)",
    iris9: "color(display-p3 0.357 0.357 0.81)",
    iris10: "color(display-p3 0.318 0.318 0.774)",
    iris11: "color(display-p3 0.337 0.326 0.748)",
    iris12: "color(display-p3 0.154 0.161 0.371)",
    cyan1: "color(display-p3 0.982 0.992 0.996)",
    cyan2: "color(display-p3 0.955 0.981 0.984)",
    cyan3: "color(display-p3 0.888 0.965 0.975)",
    cyan4: "color(display-p3 0.821 0.941 0.959)",
    cyan5: "color(display-p3 0.751 0.907 0.935)",
    cyan6: "color(display-p3 0.671 0.862 0.9)",
    cyan7: "color(display-p3 0.564 0.8 0.854)",
    cyan8: "color(display-p3 0.388 0.715 0.798)",
    cyan9: "color(display-p3 0.282 0.627 0.765)",
    cyan10: "color(display-p3 0.264 0.583 0.71)",
    cyan11: "color(display-p3 0.08 0.48 0.63)",
    cyan12: "color(display-p3 0.108 0.232 0.277)",
    jade1: "color(display-p3 0.986 0.996 0.992)",
    jade2: "color(display-p3 0.962 0.983 0.969)",
    jade3: "color(display-p3 0.912 0.965 0.932)",
    jade4: "color(display-p3 0.858 0.941 0.893)",
    jade5: "color(display-p3 0.795 0.909 0.847)",
    jade6: "color(display-p3 0.715 0.864 0.791)",
    jade7: "color(display-p3 0.603 0.802 0.718)",
    jade8: "color(display-p3 0.44 0.72 0.629)",
    jade9: "color(display-p3 0.319 0.63 0.521)",
    jade10: "color(display-p3 0.299 0.592 0.488)",
    jade11: "color(display-p3 0.15 0.5 0.37)",
    jade12: "color(display-p3 0.142 0.229 0.194)",
    grass1: "color(display-p3 0.986 0.996 0.985)",
    grass2: "color(display-p3 0.966 0.983 0.964)",
    grass3: "color(display-p3 0.923 0.965 0.917)",
    grass4: "color(display-p3 0.872 0.94 0.865)",
    grass5: "color(display-p3 0.811 0.908 0.802)",
    grass6: "color(display-p3 0.733 0.864 0.724)",
    grass7: "color(display-p3 0.628 0.803 0.622)",
    grass8: "color(display-p3 0.477 0.72 0.482)",
    grass9: "color(display-p3 0.38 0.647 0.378)",
    grass10: "color(display-p3 0.344 0.598 0.342)",
    grass11: "color(display-p3 0.263 0.488 0.261)",
    grass12: "color(display-p3 0.151 0.233 0.153)",
    mint1: "color(display-p3 0.98 0.995 0.992)",
    mint2: "color(display-p3 0.957 0.985 0.977)",
    mint3: "color(display-p3 0.888 0.972 0.95)",
    mint4: "color(display-p3 0.819 0.951 0.916)",
    mint5: "color(display-p3 0.747 0.918 0.873)",
    mint6: "color(display-p3 0.668 0.87 0.818)",
    mint7: "color(display-p3 0.567 0.805 0.744)",
    mint8: "color(display-p3 0.42 0.724 0.649)",
    mint9: "color(display-p3 0.62 0.908 0.834)",
    mint10: "color(display-p3 0.585 0.871 0.797)",
    mint11: "color(display-p3 0.203 0.463 0.397)",
    mint12: "color(display-p3 0.136 0.259 0.236)",
    lime1: "color(display-p3 0.989 0.992 0.981)",
    lime2: "color(display-p3 0.975 0.98 0.954)",
    lime3: "color(display-p3 0.939 0.965 0.851)",
    lime4: "color(display-p3 0.896 0.94 0.76)",
    lime5: "color(display-p3 0.843 0.903 0.678)",
    lime6: "color(display-p3 0.778 0.852 0.599)",
    lime7: "color(display-p3 0.694 0.784 0.508)",
    lime8: "color(display-p3 0.585 0.707 0.378)",
    lime9: "color(display-p3 0.78 0.928 0.466)",
    lime10: "color(display-p3 0.734 0.896 0.397)",
    lime11: "color(display-p3 0.386 0.482 0.227)",
    lime12: "color(display-p3 0.222 0.25 0.128)",
    bronze1: "color(display-p3 0.991 0.988 0.988)",
    bronze2: "color(display-p3 0.989 0.97 0.961)",
    bronze3: "color(display-p3 0.958 0.932 0.919)",
    bronze4: "color(display-p3 0.929 0.894 0.877)",
    bronze5: "color(display-p3 0.898 0.853 0.832)",
    bronze6: "color(display-p3 0.861 0.805 0.778)",
    bronze7: "color(display-p3 0.812 0.739 0.706)",
    bronze8: "color(display-p3 0.741 0.647 0.606)",
    bronze9: "color(display-p3 0.611 0.507 0.455)",
    bronze10: "color(display-p3 0.563 0.461 0.414)",
    bronze11: "color(display-p3 0.471 0.373 0.336)",
    bronze12: "color(display-p3 0.251 0.191 0.172)",
    gold1: "color(display-p3 0.992 0.992 0.989)",
    gold2: "color(display-p3 0.98 0.976 0.953)",
    gold3: "color(display-p3 0.947 0.94 0.909)",
    gold4: "color(display-p3 0.914 0.904 0.865)",
    gold5: "color(display-p3 0.88 0.865 0.816)",
    gold6: "color(display-p3 0.84 0.818 0.756)",
    gold7: "color(display-p3 0.788 0.753 0.677)",
    gold8: "color(display-p3 0.715 0.66 0.565)",
    gold9: "color(display-p3 0.579 0.517 0.41)",
    gold10: "color(display-p3 0.538 0.479 0.38)",
    gold11: "color(display-p3 0.433 0.386 0.305)",
    gold12: "color(display-p3 0.227 0.209 0.173)",
    brown1: "color(display-p3 0.995 0.992 0.989)",
    brown2: "color(display-p3 0.987 0.976 0.964)",
    brown3: "color(display-p3 0.959 0.936 0.909)",
    brown4: "color(display-p3 0.934 0.897 0.855)",
    brown5: "color(display-p3 0.909 0.856 0.798)",
    brown6: "color(display-p3 0.88 0.808 0.73)",
    brown7: "color(display-p3 0.841 0.742 0.639)",
    brown8: "color(display-p3 0.782 0.647 0.514)",
    brown9: "color(display-p3 0.651 0.505 0.368)",
    brown10: "color(display-p3 0.601 0.465 0.344)",
    brown11: "color(display-p3 0.485 0.374 0.288)",
    brown12: "color(display-p3 0.236 0.202 0.183)",
    amber1: "color(display-p3 0.995 0.992 0.985)",
    amber2: "color(display-p3 0.994 0.986 0.921)",
    amber3: "color(display-p3 0.994 0.969 0.782)",
    amber4: "color(display-p3 0.989 0.937 0.65)",
    amber5: "color(display-p3 0.97 0.902 0.527)",
    amber6: "color(display-p3 0.936 0.844 0.506)",
    amber7: "color(display-p3 0.89 0.762 0.443)",
    amber8: "color(display-p3 0.85 0.65 0.3)",
    amber9: "color(display-p3 1 0.77 0.26)",
    amber10: "color(display-p3 0.959 0.741 0.274)",
    amber11: "color(display-p3 0.64 0.4 0)",
    amber12: "color(display-p3 0.294 0.208 0.145)",
    transparent: {
      green1: "#00c04004",
      green2: "#00a32f0b",
      green3: "#00a43319",
      green4: "#00a83829",
      green5: "#019c393b",
      green6: "#00963c52",
      green7: "#00914071",
      green8: "#00924ba4",
      green9: "#008f4acf",
      green10: "#008647d4",
      green11: "#00713fde",
      green12: "#002616e6",
      turquoise1: "#00cc9905",
      turquoise2: "#00aa800c",
      turquoise3: "#00c69d1f",
      turquoise4: "#00c39633",
      turquoise5: "#00b49047",
      turquoise6: "#00a6855e",
      turquoise7: "#0099807c",
      turquoise8: "#009783ac",
      turquoise9: "#009e8ced",
      turquoise10: "#009684f2",
      turquoise11: "#008573",
      turquoise12: "#00332df2",
      sky1: "#00d5ff06",
      sky2: "#00a4db0e",
      sky3: "#00b3ee1e",
      sky4: "#00ace42e",
      sky5: "#00a1d841",
      sky6: "#0092ca56",
      sky7: "#0089c172",
      sky8: "#0085bf9f",
      sky9: "#00c7fe83",
      sky10: "#00bcf38b",
      sky11: "#00749e",
      sky12: "#002540e2",
      blue1: "#00008002",
      blue2: "#0040ff08",
      blue3: "#0047f112",
      blue4: "#0044ff1e",
      blue5: "#0044ff2d",
      blue6: "#003eff3e",
      blue7: "#0037ed54",
      blue8: "#0034dc72",
      blue9: "#0031d2c1",
      blue10: "#002ec9cc",
      blue11: "#002bb7c5",
      blue12: "#001046e0",
      purple1: "#aa00aa03",
      purple2: "#8000e008",
      purple3: "#8e00f112",
      purple4: "#8d00e51d",
      purple5: "#8000db2a",
      purple6: "#7a01d03b",
      purple7: "#6d00c350",
      purple8: "#6600c06c",
      purple9: "#5c00adb1",
      purple10: "#53009eb8",
      purple11: "#52009aba",
      purple12: "#250049df",
      pink1: "#ff00aa03",
      pink2: "#e0008008",
      pink3: "#f4008c16",
      pink4: "#e2008b23",
      pink5: "#d1008331",
      pink6: "#c0007840",
      pink7: "#b6006f53",
      pink8: "#af006f6c",
      pink9: "#c8007fbf",
      pink10: "#c2007ac7",
      pink11: "#b60074d6",
      pink12: "#59003bed",
      red1: "#ff000003",
      red2: "#ff000008",
      red3: "#f3000d14",
      red4: "#ff000824",
      red5: "#ff000632",
      red6: "#f8000442",
      red7: "#df000356",
      red8: "#d2000571",
      red9: "#db0007b7",
      red10: "#d10005c1",
      red11: "#c40006d3",
      red12: "#55000de8",
      orange1: "#c0400004",
      orange2: "#ff8e0012",
      orange3: "#ff9c0029",
      orange4: "#ff91014a",
      orange5: "#ff8b0065",
      orange6: "#ff81007d",
      orange7: "#ed6c008c",
      orange8: "#e35f00aa",
      orange9: "#f65e00ea",
      orange10: "#ef5f00",
      orange11: "#cc4e00",
      orange12: "#431200e2",
      yellow1: "#aaaa0006",
      yellow2: "#f4dd0016",
      yellow3: "#ffee0047",
      yellow4: "#ffe3016b",
      yellow5: "#ffd5008f",
      yellow6: "#ebbc0097",
      yellow7: "#d2a10098",
      yellow8: "#c99700c6",
      yellow9: "#ffe100d6",
      yellow10: "#ffdc00",
      yellow11: "#9e6c00",
      yellow12: "#2e2000e0",
      gray1: "color(display-p3 0 0 0 / 0.02)",
      gray2: "color(display-p3 0 0 0 / 0.039)",
      gray3: "color(display-p3 0 0 0 / 0.047)",
      gray4: "color(display-p3 0 0 0 / 0.071)",
      gray5: "color(display-p3 0 0 0 / 0.078)",
      gray6: "color(display-p3 0 0 0 / 0.114)",
      gray7: "color(display-p3 0 0 0 / 0.161)",
      gray8: "color(display-p3 0 0 0 / 0.22)",
      gray9: "color(display-p3 0 0 0 / 0.361)",
      gray10: "color(display-p3 0 0 0 / 0.478)",
      gray11: "color(display-p3 0 0 0 / 0.722)",
      gray12: "color(display-p3 0 0 0 / 0.91)",
      mauve1: "#55005503",
      mauve2: "#2b005506",
      mauve3: "#30004010",
      mauve4: "#20003618",
      mauve5: "#20003820",
      mauve6: "#14003527",
      mauve7: "#10003332",
      mauve8: "#08003145",
      mauve9: "#05001d73",
      mauve10: "#0500197d",
      mauve11: "#0400119c",
      mauve12: "#020008e0",
      slate1: "#00005503",
      slate2: "#00005506",
      slate3: "#0000330f",
      slate4: "#00002d17",
      slate5: "#0009321f",
      slate6: "#00002f26",
      slate7: "#00062e32",
      slate8: "#00083046",
      slate9: "#00051d74",
      slate10: "#00071b7f",
      slate11: "#0007149f",
      slate12: "#000509e3",
      sage1: "#00804004",
      sage2: "#00402008",
      sage3: "#002d1e11",
      sage4: "#001f1519",
      sage5: "#00180820",
      sage6: "#00140d28",
      sage7: "#00140a34",
      sage8: "#000f0847",
      sage9: "#00110b79",
      sage10: "#00100a83",
      sage11: "#000a07a0",
      sage12: "#000805e5",
      olive1: "#00550003",
      olive2: "#00490007",
      olive3: "#00200010",
      olive4: "#00160018",
      olive5: "#00180020",
      olive6: "#00140028",
      olive7: "#000f0033",
      olive8: "#040f0047",
      olive9: "#050f0078",
      olive10: "#040e0082",
      olive11: "#020a00a0",
      olive12: "#010600e3",
      sand1: "#55550003",
      sand2: "#25250007",
      sand3: "#20100010",
      sand4: "#1f150019",
      sand5: "#1f180021",
      sand6: "#19130029",
      sand7: "#19140035",
      sand8: "#1915014a",
      sand9: "#0f0f0079",
      sand10: "#0c0c0083",
      sand11: "#080800a1",
      sand12: "#060500e3",
      tomato1: "#ff000003",
      tomato2: "#ff200008",
      tomato3: "#f52b0018",
      tomato4: "#ff35002c",
      tomato5: "#ff2e003d",
      tomato6: "#f92d0050",
      tomato7: "#e7280067",
      tomato8: "#db250084",
      tomato9: "#df2600d1",
      tomato10: "#d72400da",
      tomato11: "#cd2200ea",
      tomato12: "#460900e0",
      ruby1: "#ff005503",
      ruby2: "#ff002008",
      ruby3: "#f3002515",
      ruby4: "#ff002523",
      ruby5: "#ff002a31",
      ruby6: "#e4002440",
      ruby7: "#ce002553",
      ruby8: "#c300286d",
      ruby9: "#db002cb9",
      ruby10: "#d2002cc4",
      ruby11: "#c10030db",
      ruby12: "#550016e8",
      crimson1: "#ff005503",
      crimson2: "#e0004008",
      crimson3: "#ff005216",
      crimson4: "#f8005123",
      crimson5: "#e5004f31",
      crimson6: "#d0004b41",
      crimson7: "#bf004753",
      crimson8: "#b6004a6c",
      crimson9: "#e2005bc2",
      crimson10: "#d70056cb",
      crimson11: "#c4004fe2",
      crimson12: "#530026e9",
      plum1: "#aa00ff03",
      plum2: "#c000c008",
      plum3: "#cc00cc14",
      plum4: "#c200c921",
      plum5: "#b700bd2e",
      plum6: "#a400b03d",
      plum7: "#9900a852",
      plum8: "#9000a56e",
      plum9: "#89009eb5",
      plum10: "#7f0092bb",
      plum11: "#730086c1",
      plum12: "#40004be6",
      violet1: "#5500aa03",
      violet2: "#4900ff07",
      violet3: "#4400ee0f",
      violet4: "#4300ff1b",
      violet5: "#3600ff26",
      violet6: "#3100fb35",
      violet7: "#2d01dd4a",
      violet8: "#2b00d066",
      violet9: "#2400b7a9",
      violet10: "#2300abb2",
      violet11: "#1f0099af",
      violet12: "#0b0043d9",
      iris1: "#0000ff02",
      iris2: "#0000ff07",
      iris3: "#0011ee0f",
      iris4: "#000bff19",
      iris5: "#000eff25",
      iris6: "#000aff34",
      iris7: "#0008e647",
      iris8: "#0008d964",
      iris9: "#0000c0a4",
      iris10: "#0000b6ae",
      iris11: "#0600abac",
      iris12: "#000246d8",
      cyan1: "#0099cc05",
      cyan2: "#009db10d",
      cyan3: "#00c2d121",
      cyan4: "#00bcd435",
      cyan5: "#01b4cc4a",
      cyan6: "#00a7c162",
      cyan7: "#009fbb82",
      cyan8: "#00a3c0c2",
      cyan9: "#00a2c7",
      cyan10: "#0094b7f8",
      cyan11: "#007491ef",
      cyan12: "#00323ef2",
      jade1: "#00c08004",
      jade2: "#00a3460b",
      jade3: "#00ae4819",
      jade4: "#00a85129",
      jade5: "#00a2553c",
      jade6: "#009a5753",
      jade7: "#00945f74",
      jade8: "#00976ea9",
      jade9: "#00916bd6",
      jade10: "#008764d9",
      jade11: "#007152df",
      jade12: "#002217e2",
      grass1: "#00c00004",
      grass2: "#0099000a",
      grass3: "#00970016",
      grass4: "#009f0725",
      grass5: "#00930536",
      grass6: "#008f0a4d",
      grass7: "#018b0f6b",
      grass8: "#008d199a",
      grass9: "#008619b9",
      grass10: "#007b17c1",
      grass11: "#006514d5",
      grass12: "#002006df",
      mint1: "#00d5aa06",
      mint2: "#00b18a0d",
      mint3: "#00d29e22",
      mint4: "#00cc9937",
      mint5: "#00c0914c",
      mint6: "#00b08663",
      mint7: "#00a17d81",
      mint8: "#009e7fb3",
      mint9: "#00d3a579",
      mint10: "#00c39982",
      mint11: "#007763fd",
      mint12: "#00312ae9",
      lime1: "#66990005",
      lime2: "#6b95000c",
      lime3: "#96c80029",
      lime4: "#8fc60042",
      lime5: "#81bb0059",
      lime6: "#72aa006e",
      lime7: "#61990087",
      lime8: "#559200ab",
      lime9: "#93e4009c",
      lime10: "#8fdc00b3",
      lime11: "#375f00d0",
      lime12: "#1e2900e3",
      bronze1: "#55000003",
      bronze2: "#cc33000a",
      bronze3: "#92250015",
      bronze4: "#80280020",
      bronze5: "#7423002c",
      bronze6: "#7324003a",
      bronze7: "#6c1f004c",
      bronze8: "#671c0066",
      bronze9: "#551a008d",
      bronze10: "#4c150097",
      bronze11: "#3d0f00ab",
      bronze12: "#1d0600d4",
      gold1: "#55550003",
      gold2: "#9d8a000d",
      gold3: "#75600018",
      gold4: "#6b4e0024",
      gold5: "#60460030",
      gold6: "#64440040",
      gold7: "#63420055",
      gold8: "#633d0072",
      gold9: "#5332009a",
      gold10: "#492d00a1",
      gold11: "#362100b4",
      gold12: "#130c00d4",
      brown1: "#aa550003",
      brown2: "#aa550009",
      brown3: "#a04b0018",
      brown4: "#9b4a0026",
      brown5: "#9f4d0035",
      brown6: "#a04e0048",
      brown7: "#a34e0060",
      brown8: "#9f4a0081",
      brown9: "#823c00a7",
      brown10: "#723300ac",
      brown11: "#522100b9",
      brown12: "#140600d1",
      amber1: "#c0800004",
      amber2: "#f4d10016",
      amber3: "#ffde003d",
      amber4: "#ffd40063",
      amber5: "#f8cf0088",
      amber6: "#eab5008c",
      amber7: "#dc9b009d",
      amber8: "#da8a00c9",
      amber9: "#ffb300c2",
      amber10: "#ffb300e7",
      amber11: "#ab6400",
      amber12: "#341500dd"
    }
  }
}, er = (r, o) => {
  const a = r[((o == null ? -1 : r.findIndex((l) => l === o)) + 1) % r.length];
  if (a === void 0) throw new Error("getNextThemeColor needs at least one color name.");
  return a;
}, v = {
  icon: {
    size: {
      sm: "var(--t-icon-size-sm)",
      md: "var(--t-icon-size-md)",
      lg: "var(--t-icon-size-lg)",
      xl: "var(--t-icon-size-xl)"
    },
    stroke: {
      sm: "var(--t-icon-stroke-sm)",
      md: "var(--t-icon-stroke-md)",
      lg: "var(--t-icon-stroke-lg)"
    }
  },
  modal: { size: {
    sm: { width: "var(--t-modal-size-sm-width)" },
    md: { width: "var(--t-modal-size-md-width)" },
    lg: { width: "var(--t-modal-size-lg-width)" },
    xl: {
      width: "var(--t-modal-size-xl-width)",
      height: "var(--t-modal-size-xl-height)"
    },
    fullscreen: {
      width: "var(--t-modal-size-fullscreen-width)",
      height: "var(--t-modal-size-fullscreen-height)"
    }
  } },
  text: {
    lineHeight: {
      lg: "var(--t-text-line-height-lg)",
      md: "var(--t-text-line-height-md)"
    },
    iconSizeMedium: "var(--t-text-icon-size-medium)",
    iconSizeSmall: "var(--t-text-icon-size-small)",
    iconStrikeLight: "var(--t-text-icon-strike-light)",
    iconStrikeMedium: "var(--t-text-icon-strike-medium)",
    iconStrikeBold: "var(--t-text-icon-strike-bold)"
  },
  tooltip: {
    background: "var(--t-tooltip-background)",
    color: "var(--t-tooltip-color)",
    descriptionColor: "var(--t-tooltip-description-color)"
  },
  animation: { duration: {
    instant: "var(--t-animation-duration-instant)",
    fast: "var(--t-animation-duration-fast)",
    normal: "var(--t-animation-duration-normal)",
    slow: "var(--t-animation-duration-slow)"
  } },
  spacingMultiplicator: "var(--t-spacing-multiplicator)",
  spacing: {
    0: "var(--t-spacing-0)",
    1: "var(--t-spacing-1)",
    2: "var(--t-spacing-2)",
    3: "var(--t-spacing-3)",
    4: "var(--t-spacing-4)",
    5: "var(--t-spacing-5)",
    6: "var(--t-spacing-6)",
    7: "var(--t-spacing-7)",
    8: "var(--t-spacing-8)",
    9: "var(--t-spacing-9)",
    10: "var(--t-spacing-10)",
    11: "var(--t-spacing-11)",
    12: "var(--t-spacing-12)",
    13: "var(--t-spacing-13)",
    14: "var(--t-spacing-14)",
    15: "var(--t-spacing-15)",
    16: "var(--t-spacing-16)",
    17: "var(--t-spacing-17)",
    18: "var(--t-spacing-18)",
    19: "var(--t-spacing-19)",
    20: "var(--t-spacing-20)",
    21: "var(--t-spacing-21)",
    22: "var(--t-spacing-22)",
    23: "var(--t-spacing-23)",
    24: "var(--t-spacing-24)",
    25: "var(--t-spacing-25)",
    26: "var(--t-spacing-26)",
    27: "var(--t-spacing-27)",
    28: "var(--t-spacing-28)",
    29: "var(--t-spacing-29)",
    30: "var(--t-spacing-30)",
    31: "var(--t-spacing-31)",
    32: "var(--t-spacing-32)",
    "0.5": "var(--t-spacing-0_5)",
    "1.5": "var(--t-spacing-1_5)"
  },
  betweenSiblingsGap: "var(--t-between-siblings-gap)",
  table: {
    horizontalCellMargin: "var(--t-table-horizontal-cell-margin)",
    checkboxColumnWidth: "var(--t-table-checkbox-column-width)",
    horizontalCellPadding: "var(--t-table-horizontal-cell-padding)"
  },
  sidePanelWidth: "var(--t-side-panel-width)",
  clickableElementBackgroundTransition: "var(--t-clickable-element-background-transition)",
  lastLayerZIndex: "var(--t-last-layer-z-index)",
  buttons: { secondaryTextColor: "var(--t-buttons-secondary-text-color)" },
  accent: {
    primary: "var(--t-accent-primary)",
    secondary: "var(--t-accent-secondary)",
    tertiary: "var(--t-accent-tertiary)",
    quaternary: "var(--t-accent-quaternary)",
    accent3570: "var(--t-accent-accent3570)",
    accent4060: "var(--t-accent-accent4060)",
    accent1: "var(--t-accent-accent1)",
    accent2: "var(--t-accent-accent2)",
    accent3: "var(--t-accent-accent3)",
    accent4: "var(--t-accent-accent4)",
    accent5: "var(--t-accent-accent5)",
    accent6: "var(--t-accent-accent6)",
    accent7: "var(--t-accent-accent7)",
    accent8: "var(--t-accent-accent8)",
    accent9: "var(--t-accent-accent9)",
    accent10: "var(--t-accent-accent10)",
    accent11: "var(--t-accent-accent11)",
    accent12: "var(--t-accent-accent12)"
  },
  background: {
    noisy: "var(--t-background-noisy)",
    primary: "var(--t-background-primary)",
    secondary: "var(--t-background-secondary)",
    tertiary: "var(--t-background-tertiary)",
    quaternary: "var(--t-background-quaternary)",
    invertedPrimary: "var(--t-background-inverted-primary)",
    invertedSecondary: "var(--t-background-inverted-secondary)",
    danger: "var(--t-background-danger)",
    transparent: {
      primary: "var(--t-background-transparent-primary)",
      secondary: "var(--t-background-transparent-secondary)",
      strong: "var(--t-background-transparent-strong)",
      medium: "var(--t-background-transparent-medium)",
      light: "var(--t-background-transparent-light)",
      lighter: "var(--t-background-transparent-lighter)",
      danger: "var(--t-background-transparent-danger)",
      blue: "var(--t-background-transparent-blue)",
      orange: "var(--t-background-transparent-orange)",
      success: "var(--t-background-transparent-success)"
    },
    overlayPrimary: "var(--t-background-overlay-primary)",
    overlaySecondary: "var(--t-background-overlay-secondary)",
    overlayTertiary: "var(--t-background-overlay-tertiary)",
    radialGradient: "var(--t-background-radial-gradient)",
    radialGradientHover: "var(--t-background-radial-gradient-hover)",
    primaryInverted: "var(--t-background-primary-inverted)",
    primaryInvertedHover: "var(--t-background-primary-inverted-hover)"
  },
  blur: {
    light: "var(--t-blur-light)",
    medium: "var(--t-blur-medium)",
    strong: "var(--t-blur-strong)"
  },
  border: {
    color: {
      strong: "var(--t-border-color-strong)",
      medium: "var(--t-border-color-medium)",
      light: "var(--t-border-color-light)",
      secondaryInverted: "var(--t-border-color-secondary-inverted)",
      inverted: "var(--t-border-color-inverted)",
      danger: "var(--t-border-color-danger)",
      blue: "var(--t-border-color-blue)",
      transparentStrong: "var(--t-border-color-transparent-strong)"
    },
    radius: {
      xs: "var(--t-border-radius-xs)",
      sm: "var(--t-border-radius-sm)",
      md: "var(--t-border-radius-md)",
      smRound: "var(--t-border-radius-sm-round)",
      mdRound: "var(--t-border-radius-md-round)",
      lg: "var(--t-border-radius-lg)",
      xl: "var(--t-border-radius-xl)",
      xxl: "var(--t-border-radius-xxl)",
      pill: "var(--t-border-radius-pill)",
      rounded: "var(--t-border-radius-rounded)"
    }
  },
  boxShadow: {
    color: "var(--t-box-shadow-color)",
    light: "var(--t-box-shadow-light)",
    sidebar: "var(--t-box-shadow-sidebar)",
    strong: "var(--t-box-shadow-strong)",
    underline: "var(--t-box-shadow-underline)",
    superHeavy: "var(--t-box-shadow-super-heavy)"
  },
  font: {
    color: {
      primary: "var(--t-font-color-primary)",
      secondary: "var(--t-font-color-secondary)",
      tertiary: "var(--t-font-color-tertiary)",
      light: "var(--t-font-color-light)",
      extraLight: "var(--t-font-color-extra-light)",
      inverted: "var(--t-font-color-inverted)",
      onAccent: "var(--t-font-color-on-accent)",
      danger: "var(--t-font-color-danger)"
    },
    size: {
      xxs: "var(--t-font-size-xxs)",
      xs: "var(--t-font-size-xs)",
      sm: "var(--t-font-size-sm)",
      md: "var(--t-font-size-md)",
      lg: "var(--t-font-size-lg)",
      xl: "var(--t-font-size-xl)",
      xxl: "var(--t-font-size-xxl)"
    },
    weight: {
      regular: "var(--t-font-weight-regular)",
      medium: "var(--t-font-weight-medium)",
      semiBold: "var(--t-font-weight-semi-bold)"
    },
    family: "var(--t-font-family)"
  },
  name: "var(--t-name)",
  snackBar: {
    success: {
      color: "var(--t-snack-bar-success-color)",
      backgroundColor: "var(--t-snack-bar-success-background-color)"
    },
    error: {
      color: "var(--t-snack-bar-error-color)",
      backgroundColor: "var(--t-snack-bar-error-background-color)"
    },
    warning: {
      color: "var(--t-snack-bar-warning-color)",
      backgroundColor: "var(--t-snack-bar-warning-background-color)"
    },
    info: {
      color: "var(--t-snack-bar-info-color)",
      backgroundColor: "var(--t-snack-bar-info-background-color)"
    },
    default: {
      color: "var(--t-snack-bar-default-color)",
      backgroundColor: "var(--t-snack-bar-default-background-color)"
    }
  },
  tag: {
    text: {
      gray: "var(--t-tag-text-gray)",
      mauve: "var(--t-tag-text-mauve)",
      slate: "var(--t-tag-text-slate)",
      sage: "var(--t-tag-text-sage)",
      olive: "var(--t-tag-text-olive)",
      sand: "var(--t-tag-text-sand)",
      tomato: "var(--t-tag-text-tomato)",
      red: "var(--t-tag-text-red)",
      ruby: "var(--t-tag-text-ruby)",
      crimson: "var(--t-tag-text-crimson)",
      pink: "var(--t-tag-text-pink)",
      plum: "var(--t-tag-text-plum)",
      purple: "var(--t-tag-text-purple)",
      violet: "var(--t-tag-text-violet)",
      iris: "var(--t-tag-text-iris)",
      cyan: "var(--t-tag-text-cyan)",
      turquoise: "var(--t-tag-text-turquoise)",
      sky: "var(--t-tag-text-sky)",
      blue: "var(--t-tag-text-blue)",
      jade: "var(--t-tag-text-jade)",
      green: "var(--t-tag-text-green)",
      grass: "var(--t-tag-text-grass)",
      mint: "var(--t-tag-text-mint)",
      lime: "var(--t-tag-text-lime)",
      bronze: "var(--t-tag-text-bronze)",
      gold: "var(--t-tag-text-gold)",
      brown: "var(--t-tag-text-brown)",
      orange: "var(--t-tag-text-orange)",
      amber: "var(--t-tag-text-amber)",
      yellow: "var(--t-tag-text-yellow)"
    },
    background: {
      gray: "var(--t-tag-background-gray)",
      mauve: "var(--t-tag-background-mauve)",
      slate: "var(--t-tag-background-slate)",
      sage: "var(--t-tag-background-sage)",
      olive: "var(--t-tag-background-olive)",
      sand: "var(--t-tag-background-sand)",
      tomato: "var(--t-tag-background-tomato)",
      red: "var(--t-tag-background-red)",
      ruby: "var(--t-tag-background-ruby)",
      crimson: "var(--t-tag-background-crimson)",
      pink: "var(--t-tag-background-pink)",
      plum: "var(--t-tag-background-plum)",
      purple: "var(--t-tag-background-purple)",
      violet: "var(--t-tag-background-violet)",
      iris: "var(--t-tag-background-iris)",
      cyan: "var(--t-tag-background-cyan)",
      turquoise: "var(--t-tag-background-turquoise)",
      sky: "var(--t-tag-background-sky)",
      blue: "var(--t-tag-background-blue)",
      jade: "var(--t-tag-background-jade)",
      green: "var(--t-tag-background-green)",
      grass: "var(--t-tag-background-grass)",
      mint: "var(--t-tag-background-mint)",
      lime: "var(--t-tag-background-lime)",
      bronze: "var(--t-tag-background-bronze)",
      gold: "var(--t-tag-background-gold)",
      brown: "var(--t-tag-background-brown)",
      orange: "var(--t-tag-background-orange)",
      amber: "var(--t-tag-background-amber)",
      yellow: "var(--t-tag-background-yellow)"
    }
  },
  code: {
    text: {
      gray: "var(--t-code-text-gray)",
      sky: "var(--t-code-text-sky)",
      pink: "var(--t-code-text-pink)",
      orange: "var(--t-code-text-orange)",
      green: "var(--t-code-text-green)"
    },
    font: { family: "var(--t-code-font-family)" }
  },
  IllustrationIcon: {
    color: {
      blue: "var(--t-illustration-icon-color-blue)",
      gray: "var(--t-illustration-icon-color-gray)"
    },
    fill: {
      blue: "var(--t-illustration-icon-fill-blue)",
      gray: "var(--t-illustration-icon-fill-gray)"
    }
  },
  grayScale: {
    gray1: "var(--t-gray-scale-gray1)",
    gray2: "var(--t-gray-scale-gray2)",
    gray3: "var(--t-gray-scale-gray3)",
    gray4: "var(--t-gray-scale-gray4)",
    gray5: "var(--t-gray-scale-gray5)",
    gray6: "var(--t-gray-scale-gray6)",
    gray7: "var(--t-gray-scale-gray7)",
    gray8: "var(--t-gray-scale-gray8)",
    gray9: "var(--t-gray-scale-gray9)",
    gray10: "var(--t-gray-scale-gray10)",
    gray11: "var(--t-gray-scale-gray11)",
    gray12: "var(--t-gray-scale-gray12)"
  },
  color: {
    red: "var(--t-color-red)",
    ruby: "var(--t-color-ruby)",
    crimson: "var(--t-color-crimson)",
    tomato: "var(--t-color-tomato)",
    orange: "var(--t-color-orange)",
    amber: "var(--t-color-amber)",
    yellow: "var(--t-color-yellow)",
    lime: "var(--t-color-lime)",
    grass: "var(--t-color-grass)",
    green: "var(--t-color-green)",
    jade: "var(--t-color-jade)",
    mint: "var(--t-color-mint)",
    turquoise: "var(--t-color-turquoise)",
    cyan: "var(--t-color-cyan)",
    sky: "var(--t-color-sky)",
    blue: "var(--t-color-blue)",
    iris: "var(--t-color-iris)",
    violet: "var(--t-color-violet)",
    purple: "var(--t-color-purple)",
    plum: "var(--t-color-plum)",
    pink: "var(--t-color-pink)",
    bronze: "var(--t-color-bronze)",
    gold: "var(--t-color-gold)",
    brown: "var(--t-color-brown)",
    gray: "var(--t-color-gray)",
    yellow1: "var(--t-color-yellow1)",
    yellow2: "var(--t-color-yellow2)",
    yellow3: "var(--t-color-yellow3)",
    yellow4: "var(--t-color-yellow4)",
    yellow5: "var(--t-color-yellow5)",
    yellow6: "var(--t-color-yellow6)",
    yellow7: "var(--t-color-yellow7)",
    yellow8: "var(--t-color-yellow8)",
    yellow9: "var(--t-color-yellow9)",
    yellow10: "var(--t-color-yellow10)",
    yellow11: "var(--t-color-yellow11)",
    yellow12: "var(--t-color-yellow12)",
    green1: "var(--t-color-green1)",
    green2: "var(--t-color-green2)",
    green3: "var(--t-color-green3)",
    green4: "var(--t-color-green4)",
    green5: "var(--t-color-green5)",
    green6: "var(--t-color-green6)",
    green7: "var(--t-color-green7)",
    green8: "var(--t-color-green8)",
    green9: "var(--t-color-green9)",
    green10: "var(--t-color-green10)",
    green11: "var(--t-color-green11)",
    green12: "var(--t-color-green12)",
    turquoise1: "var(--t-color-turquoise1)",
    turquoise2: "var(--t-color-turquoise2)",
    turquoise3: "var(--t-color-turquoise3)",
    turquoise4: "var(--t-color-turquoise4)",
    turquoise5: "var(--t-color-turquoise5)",
    turquoise6: "var(--t-color-turquoise6)",
    turquoise7: "var(--t-color-turquoise7)",
    turquoise8: "var(--t-color-turquoise8)",
    turquoise9: "var(--t-color-turquoise9)",
    turquoise10: "var(--t-color-turquoise10)",
    turquoise11: "var(--t-color-turquoise11)",
    turquoise12: "var(--t-color-turquoise12)",
    sky1: "var(--t-color-sky1)",
    sky2: "var(--t-color-sky2)",
    sky3: "var(--t-color-sky3)",
    sky4: "var(--t-color-sky4)",
    sky5: "var(--t-color-sky5)",
    sky6: "var(--t-color-sky6)",
    sky7: "var(--t-color-sky7)",
    sky8: "var(--t-color-sky8)",
    sky9: "var(--t-color-sky9)",
    sky10: "var(--t-color-sky10)",
    sky11: "var(--t-color-sky11)",
    sky12: "var(--t-color-sky12)",
    blue1: "var(--t-color-blue1)",
    blue2: "var(--t-color-blue2)",
    blue3: "var(--t-color-blue3)",
    blue4: "var(--t-color-blue4)",
    blue5: "var(--t-color-blue5)",
    blue6: "var(--t-color-blue6)",
    blue7: "var(--t-color-blue7)",
    blue8: "var(--t-color-blue8)",
    blue9: "var(--t-color-blue9)",
    blue10: "var(--t-color-blue10)",
    blue11: "var(--t-color-blue11)",
    blue12: "var(--t-color-blue12)",
    purple1: "var(--t-color-purple1)",
    purple2: "var(--t-color-purple2)",
    purple3: "var(--t-color-purple3)",
    purple4: "var(--t-color-purple4)",
    purple5: "var(--t-color-purple5)",
    purple6: "var(--t-color-purple6)",
    purple7: "var(--t-color-purple7)",
    purple8: "var(--t-color-purple8)",
    purple9: "var(--t-color-purple9)",
    purple10: "var(--t-color-purple10)",
    purple11: "var(--t-color-purple11)",
    purple12: "var(--t-color-purple12)",
    pink1: "var(--t-color-pink1)",
    pink2: "var(--t-color-pink2)",
    pink3: "var(--t-color-pink3)",
    pink4: "var(--t-color-pink4)",
    pink5: "var(--t-color-pink5)",
    pink6: "var(--t-color-pink6)",
    pink7: "var(--t-color-pink7)",
    pink8: "var(--t-color-pink8)",
    pink9: "var(--t-color-pink9)",
    pink10: "var(--t-color-pink10)",
    pink11: "var(--t-color-pink11)",
    pink12: "var(--t-color-pink12)",
    red1: "var(--t-color-red1)",
    red2: "var(--t-color-red2)",
    red3: "var(--t-color-red3)",
    red4: "var(--t-color-red4)",
    red5: "var(--t-color-red5)",
    red6: "var(--t-color-red6)",
    red7: "var(--t-color-red7)",
    red8: "var(--t-color-red8)",
    red9: "var(--t-color-red9)",
    red10: "var(--t-color-red10)",
    red11: "var(--t-color-red11)",
    red12: "var(--t-color-red12)",
    orange1: "var(--t-color-orange1)",
    orange2: "var(--t-color-orange2)",
    orange3: "var(--t-color-orange3)",
    orange4: "var(--t-color-orange4)",
    orange5: "var(--t-color-orange5)",
    orange6: "var(--t-color-orange6)",
    orange7: "var(--t-color-orange7)",
    orange8: "var(--t-color-orange8)",
    orange9: "var(--t-color-orange9)",
    orange10: "var(--t-color-orange10)",
    orange11: "var(--t-color-orange11)",
    orange12: "var(--t-color-orange12)",
    gray1: "var(--t-color-gray1)",
    gray2: "var(--t-color-gray2)",
    gray3: "var(--t-color-gray3)",
    gray4: "var(--t-color-gray4)",
    gray5: "var(--t-color-gray5)",
    gray6: "var(--t-color-gray6)",
    gray7: "var(--t-color-gray7)",
    gray8: "var(--t-color-gray8)",
    gray9: "var(--t-color-gray9)",
    gray10: "var(--t-color-gray10)",
    gray11: "var(--t-color-gray11)",
    gray12: "var(--t-color-gray12)",
    mauve1: "var(--t-color-mauve1)",
    mauve2: "var(--t-color-mauve2)",
    mauve3: "var(--t-color-mauve3)",
    mauve4: "var(--t-color-mauve4)",
    mauve5: "var(--t-color-mauve5)",
    mauve6: "var(--t-color-mauve6)",
    mauve7: "var(--t-color-mauve7)",
    mauve8: "var(--t-color-mauve8)",
    mauve9: "var(--t-color-mauve9)",
    mauve10: "var(--t-color-mauve10)",
    mauve11: "var(--t-color-mauve11)",
    mauve12: "var(--t-color-mauve12)",
    slate1: "var(--t-color-slate1)",
    slate2: "var(--t-color-slate2)",
    slate3: "var(--t-color-slate3)",
    slate4: "var(--t-color-slate4)",
    slate5: "var(--t-color-slate5)",
    slate6: "var(--t-color-slate6)",
    slate7: "var(--t-color-slate7)",
    slate8: "var(--t-color-slate8)",
    slate9: "var(--t-color-slate9)",
    slate10: "var(--t-color-slate10)",
    slate11: "var(--t-color-slate11)",
    slate12: "var(--t-color-slate12)",
    sage1: "var(--t-color-sage1)",
    sage2: "var(--t-color-sage2)",
    sage3: "var(--t-color-sage3)",
    sage4: "var(--t-color-sage4)",
    sage5: "var(--t-color-sage5)",
    sage6: "var(--t-color-sage6)",
    sage7: "var(--t-color-sage7)",
    sage8: "var(--t-color-sage8)",
    sage9: "var(--t-color-sage9)",
    sage10: "var(--t-color-sage10)",
    sage11: "var(--t-color-sage11)",
    sage12: "var(--t-color-sage12)",
    olive1: "var(--t-color-olive1)",
    olive2: "var(--t-color-olive2)",
    olive3: "var(--t-color-olive3)",
    olive4: "var(--t-color-olive4)",
    olive5: "var(--t-color-olive5)",
    olive6: "var(--t-color-olive6)",
    olive7: "var(--t-color-olive7)",
    olive8: "var(--t-color-olive8)",
    olive9: "var(--t-color-olive9)",
    olive10: "var(--t-color-olive10)",
    olive11: "var(--t-color-olive11)",
    olive12: "var(--t-color-olive12)",
    sand1: "var(--t-color-sand1)",
    sand2: "var(--t-color-sand2)",
    sand3: "var(--t-color-sand3)",
    sand4: "var(--t-color-sand4)",
    sand5: "var(--t-color-sand5)",
    sand6: "var(--t-color-sand6)",
    sand7: "var(--t-color-sand7)",
    sand8: "var(--t-color-sand8)",
    sand9: "var(--t-color-sand9)",
    sand10: "var(--t-color-sand10)",
    sand11: "var(--t-color-sand11)",
    sand12: "var(--t-color-sand12)",
    tomato1: "var(--t-color-tomato1)",
    tomato2: "var(--t-color-tomato2)",
    tomato3: "var(--t-color-tomato3)",
    tomato4: "var(--t-color-tomato4)",
    tomato5: "var(--t-color-tomato5)",
    tomato6: "var(--t-color-tomato6)",
    tomato7: "var(--t-color-tomato7)",
    tomato8: "var(--t-color-tomato8)",
    tomato9: "var(--t-color-tomato9)",
    tomato10: "var(--t-color-tomato10)",
    tomato11: "var(--t-color-tomato11)",
    tomato12: "var(--t-color-tomato12)",
    ruby1: "var(--t-color-ruby1)",
    ruby2: "var(--t-color-ruby2)",
    ruby3: "var(--t-color-ruby3)",
    ruby4: "var(--t-color-ruby4)",
    ruby5: "var(--t-color-ruby5)",
    ruby6: "var(--t-color-ruby6)",
    ruby7: "var(--t-color-ruby7)",
    ruby8: "var(--t-color-ruby8)",
    ruby9: "var(--t-color-ruby9)",
    ruby10: "var(--t-color-ruby10)",
    ruby11: "var(--t-color-ruby11)",
    ruby12: "var(--t-color-ruby12)",
    crimson1: "var(--t-color-crimson1)",
    crimson2: "var(--t-color-crimson2)",
    crimson3: "var(--t-color-crimson3)",
    crimson4: "var(--t-color-crimson4)",
    crimson5: "var(--t-color-crimson5)",
    crimson6: "var(--t-color-crimson6)",
    crimson7: "var(--t-color-crimson7)",
    crimson8: "var(--t-color-crimson8)",
    crimson9: "var(--t-color-crimson9)",
    crimson10: "var(--t-color-crimson10)",
    crimson11: "var(--t-color-crimson11)",
    crimson12: "var(--t-color-crimson12)",
    plum1: "var(--t-color-plum1)",
    plum2: "var(--t-color-plum2)",
    plum3: "var(--t-color-plum3)",
    plum4: "var(--t-color-plum4)",
    plum5: "var(--t-color-plum5)",
    plum6: "var(--t-color-plum6)",
    plum7: "var(--t-color-plum7)",
    plum8: "var(--t-color-plum8)",
    plum9: "var(--t-color-plum9)",
    plum10: "var(--t-color-plum10)",
    plum11: "var(--t-color-plum11)",
    plum12: "var(--t-color-plum12)",
    violet1: "var(--t-color-violet1)",
    violet2: "var(--t-color-violet2)",
    violet3: "var(--t-color-violet3)",
    violet4: "var(--t-color-violet4)",
    violet5: "var(--t-color-violet5)",
    violet6: "var(--t-color-violet6)",
    violet7: "var(--t-color-violet7)",
    violet8: "var(--t-color-violet8)",
    violet9: "var(--t-color-violet9)",
    violet10: "var(--t-color-violet10)",
    violet11: "var(--t-color-violet11)",
    violet12: "var(--t-color-violet12)",
    iris1: "var(--t-color-iris1)",
    iris2: "var(--t-color-iris2)",
    iris3: "var(--t-color-iris3)",
    iris4: "var(--t-color-iris4)",
    iris5: "var(--t-color-iris5)",
    iris6: "var(--t-color-iris6)",
    iris7: "var(--t-color-iris7)",
    iris8: "var(--t-color-iris8)",
    iris9: "var(--t-color-iris9)",
    iris10: "var(--t-color-iris10)",
    iris11: "var(--t-color-iris11)",
    iris12: "var(--t-color-iris12)",
    cyan1: "var(--t-color-cyan1)",
    cyan2: "var(--t-color-cyan2)",
    cyan3: "var(--t-color-cyan3)",
    cyan4: "var(--t-color-cyan4)",
    cyan5: "var(--t-color-cyan5)",
    cyan6: "var(--t-color-cyan6)",
    cyan7: "var(--t-color-cyan7)",
    cyan8: "var(--t-color-cyan8)",
    cyan9: "var(--t-color-cyan9)",
    cyan10: "var(--t-color-cyan10)",
    cyan11: "var(--t-color-cyan11)",
    cyan12: "var(--t-color-cyan12)",
    jade1: "var(--t-color-jade1)",
    jade2: "var(--t-color-jade2)",
    jade3: "var(--t-color-jade3)",
    jade4: "var(--t-color-jade4)",
    jade5: "var(--t-color-jade5)",
    jade6: "var(--t-color-jade6)",
    jade7: "var(--t-color-jade7)",
    jade8: "var(--t-color-jade8)",
    jade9: "var(--t-color-jade9)",
    jade10: "var(--t-color-jade10)",
    jade11: "var(--t-color-jade11)",
    jade12: "var(--t-color-jade12)",
    grass1: "var(--t-color-grass1)",
    grass2: "var(--t-color-grass2)",
    grass3: "var(--t-color-grass3)",
    grass4: "var(--t-color-grass4)",
    grass5: "var(--t-color-grass5)",
    grass6: "var(--t-color-grass6)",
    grass7: "var(--t-color-grass7)",
    grass8: "var(--t-color-grass8)",
    grass9: "var(--t-color-grass9)",
    grass10: "var(--t-color-grass10)",
    grass11: "var(--t-color-grass11)",
    grass12: "var(--t-color-grass12)",
    mint1: "var(--t-color-mint1)",
    mint2: "var(--t-color-mint2)",
    mint3: "var(--t-color-mint3)",
    mint4: "var(--t-color-mint4)",
    mint5: "var(--t-color-mint5)",
    mint6: "var(--t-color-mint6)",
    mint7: "var(--t-color-mint7)",
    mint8: "var(--t-color-mint8)",
    mint9: "var(--t-color-mint9)",
    mint10: "var(--t-color-mint10)",
    mint11: "var(--t-color-mint11)",
    mint12: "var(--t-color-mint12)",
    lime1: "var(--t-color-lime1)",
    lime2: "var(--t-color-lime2)",
    lime3: "var(--t-color-lime3)",
    lime4: "var(--t-color-lime4)",
    lime5: "var(--t-color-lime5)",
    lime6: "var(--t-color-lime6)",
    lime7: "var(--t-color-lime7)",
    lime8: "var(--t-color-lime8)",
    lime9: "var(--t-color-lime9)",
    lime10: "var(--t-color-lime10)",
    lime11: "var(--t-color-lime11)",
    lime12: "var(--t-color-lime12)",
    bronze1: "var(--t-color-bronze1)",
    bronze2: "var(--t-color-bronze2)",
    bronze3: "var(--t-color-bronze3)",
    bronze4: "var(--t-color-bronze4)",
    bronze5: "var(--t-color-bronze5)",
    bronze6: "var(--t-color-bronze6)",
    bronze7: "var(--t-color-bronze7)",
    bronze8: "var(--t-color-bronze8)",
    bronze9: "var(--t-color-bronze9)",
    bronze10: "var(--t-color-bronze10)",
    bronze11: "var(--t-color-bronze11)",
    bronze12: "var(--t-color-bronze12)",
    gold1: "var(--t-color-gold1)",
    gold2: "var(--t-color-gold2)",
    gold3: "var(--t-color-gold3)",
    gold4: "var(--t-color-gold4)",
    gold5: "var(--t-color-gold5)",
    gold6: "var(--t-color-gold6)",
    gold7: "var(--t-color-gold7)",
    gold8: "var(--t-color-gold8)",
    gold9: "var(--t-color-gold9)",
    gold10: "var(--t-color-gold10)",
    gold11: "var(--t-color-gold11)",
    gold12: "var(--t-color-gold12)",
    brown1: "var(--t-color-brown1)",
    brown2: "var(--t-color-brown2)",
    brown3: "var(--t-color-brown3)",
    brown4: "var(--t-color-brown4)",
    brown5: "var(--t-color-brown5)",
    brown6: "var(--t-color-brown6)",
    brown7: "var(--t-color-brown7)",
    brown8: "var(--t-color-brown8)",
    brown9: "var(--t-color-brown9)",
    brown10: "var(--t-color-brown10)",
    brown11: "var(--t-color-brown11)",
    brown12: "var(--t-color-brown12)",
    amber1: "var(--t-color-amber1)",
    amber2: "var(--t-color-amber2)",
    amber3: "var(--t-color-amber3)",
    amber4: "var(--t-color-amber4)",
    amber5: "var(--t-color-amber5)",
    amber6: "var(--t-color-amber6)",
    amber7: "var(--t-color-amber7)",
    amber8: "var(--t-color-amber8)",
    amber9: "var(--t-color-amber9)",
    amber10: "var(--t-color-amber10)",
    amber11: "var(--t-color-amber11)",
    amber12: "var(--t-color-amber12)",
    transparent: {
      green1: "var(--t-color-transparent-green1)",
      green2: "var(--t-color-transparent-green2)",
      green3: "var(--t-color-transparent-green3)",
      green4: "var(--t-color-transparent-green4)",
      green5: "var(--t-color-transparent-green5)",
      green6: "var(--t-color-transparent-green6)",
      green7: "var(--t-color-transparent-green7)",
      green8: "var(--t-color-transparent-green8)",
      green9: "var(--t-color-transparent-green9)",
      green10: "var(--t-color-transparent-green10)",
      green11: "var(--t-color-transparent-green11)",
      green12: "var(--t-color-transparent-green12)",
      turquoise1: "var(--t-color-transparent-turquoise1)",
      turquoise2: "var(--t-color-transparent-turquoise2)",
      turquoise3: "var(--t-color-transparent-turquoise3)",
      turquoise4: "var(--t-color-transparent-turquoise4)",
      turquoise5: "var(--t-color-transparent-turquoise5)",
      turquoise6: "var(--t-color-transparent-turquoise6)",
      turquoise7: "var(--t-color-transparent-turquoise7)",
      turquoise8: "var(--t-color-transparent-turquoise8)",
      turquoise9: "var(--t-color-transparent-turquoise9)",
      turquoise10: "var(--t-color-transparent-turquoise10)",
      turquoise11: "var(--t-color-transparent-turquoise11)",
      turquoise12: "var(--t-color-transparent-turquoise12)",
      sky1: "var(--t-color-transparent-sky1)",
      sky2: "var(--t-color-transparent-sky2)",
      sky3: "var(--t-color-transparent-sky3)",
      sky4: "var(--t-color-transparent-sky4)",
      sky5: "var(--t-color-transparent-sky5)",
      sky6: "var(--t-color-transparent-sky6)",
      sky7: "var(--t-color-transparent-sky7)",
      sky8: "var(--t-color-transparent-sky8)",
      sky9: "var(--t-color-transparent-sky9)",
      sky10: "var(--t-color-transparent-sky10)",
      sky11: "var(--t-color-transparent-sky11)",
      sky12: "var(--t-color-transparent-sky12)",
      blue1: "var(--t-color-transparent-blue1)",
      blue2: "var(--t-color-transparent-blue2)",
      blue3: "var(--t-color-transparent-blue3)",
      blue4: "var(--t-color-transparent-blue4)",
      blue5: "var(--t-color-transparent-blue5)",
      blue6: "var(--t-color-transparent-blue6)",
      blue7: "var(--t-color-transparent-blue7)",
      blue8: "var(--t-color-transparent-blue8)",
      blue9: "var(--t-color-transparent-blue9)",
      blue10: "var(--t-color-transparent-blue10)",
      blue11: "var(--t-color-transparent-blue11)",
      blue12: "var(--t-color-transparent-blue12)",
      purple1: "var(--t-color-transparent-purple1)",
      purple2: "var(--t-color-transparent-purple2)",
      purple3: "var(--t-color-transparent-purple3)",
      purple4: "var(--t-color-transparent-purple4)",
      purple5: "var(--t-color-transparent-purple5)",
      purple6: "var(--t-color-transparent-purple6)",
      purple7: "var(--t-color-transparent-purple7)",
      purple8: "var(--t-color-transparent-purple8)",
      purple9: "var(--t-color-transparent-purple9)",
      purple10: "var(--t-color-transparent-purple10)",
      purple11: "var(--t-color-transparent-purple11)",
      purple12: "var(--t-color-transparent-purple12)",
      pink1: "var(--t-color-transparent-pink1)",
      pink2: "var(--t-color-transparent-pink2)",
      pink3: "var(--t-color-transparent-pink3)",
      pink4: "var(--t-color-transparent-pink4)",
      pink5: "var(--t-color-transparent-pink5)",
      pink6: "var(--t-color-transparent-pink6)",
      pink7: "var(--t-color-transparent-pink7)",
      pink8: "var(--t-color-transparent-pink8)",
      pink9: "var(--t-color-transparent-pink9)",
      pink10: "var(--t-color-transparent-pink10)",
      pink11: "var(--t-color-transparent-pink11)",
      pink12: "var(--t-color-transparent-pink12)",
      red1: "var(--t-color-transparent-red1)",
      red2: "var(--t-color-transparent-red2)",
      red3: "var(--t-color-transparent-red3)",
      red4: "var(--t-color-transparent-red4)",
      red5: "var(--t-color-transparent-red5)",
      red6: "var(--t-color-transparent-red6)",
      red7: "var(--t-color-transparent-red7)",
      red8: "var(--t-color-transparent-red8)",
      red9: "var(--t-color-transparent-red9)",
      red10: "var(--t-color-transparent-red10)",
      red11: "var(--t-color-transparent-red11)",
      red12: "var(--t-color-transparent-red12)",
      orange1: "var(--t-color-transparent-orange1)",
      orange2: "var(--t-color-transparent-orange2)",
      orange3: "var(--t-color-transparent-orange3)",
      orange4: "var(--t-color-transparent-orange4)",
      orange5: "var(--t-color-transparent-orange5)",
      orange6: "var(--t-color-transparent-orange6)",
      orange7: "var(--t-color-transparent-orange7)",
      orange8: "var(--t-color-transparent-orange8)",
      orange9: "var(--t-color-transparent-orange9)",
      orange10: "var(--t-color-transparent-orange10)",
      orange11: "var(--t-color-transparent-orange11)",
      orange12: "var(--t-color-transparent-orange12)",
      yellow1: "var(--t-color-transparent-yellow1)",
      yellow2: "var(--t-color-transparent-yellow2)",
      yellow3: "var(--t-color-transparent-yellow3)",
      yellow4: "var(--t-color-transparent-yellow4)",
      yellow5: "var(--t-color-transparent-yellow5)",
      yellow6: "var(--t-color-transparent-yellow6)",
      yellow7: "var(--t-color-transparent-yellow7)",
      yellow8: "var(--t-color-transparent-yellow8)",
      yellow9: "var(--t-color-transparent-yellow9)",
      yellow10: "var(--t-color-transparent-yellow10)",
      yellow11: "var(--t-color-transparent-yellow11)",
      yellow12: "var(--t-color-transparent-yellow12)",
      gray1: "var(--t-color-transparent-gray1)",
      gray2: "var(--t-color-transparent-gray2)",
      gray3: "var(--t-color-transparent-gray3)",
      gray4: "var(--t-color-transparent-gray4)",
      gray5: "var(--t-color-transparent-gray5)",
      gray6: "var(--t-color-transparent-gray6)",
      gray7: "var(--t-color-transparent-gray7)",
      gray8: "var(--t-color-transparent-gray8)",
      gray9: "var(--t-color-transparent-gray9)",
      gray10: "var(--t-color-transparent-gray10)",
      gray11: "var(--t-color-transparent-gray11)",
      gray12: "var(--t-color-transparent-gray12)",
      mauve1: "var(--t-color-transparent-mauve1)",
      mauve2: "var(--t-color-transparent-mauve2)",
      mauve3: "var(--t-color-transparent-mauve3)",
      mauve4: "var(--t-color-transparent-mauve4)",
      mauve5: "var(--t-color-transparent-mauve5)",
      mauve6: "var(--t-color-transparent-mauve6)",
      mauve7: "var(--t-color-transparent-mauve7)",
      mauve8: "var(--t-color-transparent-mauve8)",
      mauve9: "var(--t-color-transparent-mauve9)",
      mauve10: "var(--t-color-transparent-mauve10)",
      mauve11: "var(--t-color-transparent-mauve11)",
      mauve12: "var(--t-color-transparent-mauve12)",
      slate1: "var(--t-color-transparent-slate1)",
      slate2: "var(--t-color-transparent-slate2)",
      slate3: "var(--t-color-transparent-slate3)",
      slate4: "var(--t-color-transparent-slate4)",
      slate5: "var(--t-color-transparent-slate5)",
      slate6: "var(--t-color-transparent-slate6)",
      slate7: "var(--t-color-transparent-slate7)",
      slate8: "var(--t-color-transparent-slate8)",
      slate9: "var(--t-color-transparent-slate9)",
      slate10: "var(--t-color-transparent-slate10)",
      slate11: "var(--t-color-transparent-slate11)",
      slate12: "var(--t-color-transparent-slate12)",
      sage1: "var(--t-color-transparent-sage1)",
      sage2: "var(--t-color-transparent-sage2)",
      sage3: "var(--t-color-transparent-sage3)",
      sage4: "var(--t-color-transparent-sage4)",
      sage5: "var(--t-color-transparent-sage5)",
      sage6: "var(--t-color-transparent-sage6)",
      sage7: "var(--t-color-transparent-sage7)",
      sage8: "var(--t-color-transparent-sage8)",
      sage9: "var(--t-color-transparent-sage9)",
      sage10: "var(--t-color-transparent-sage10)",
      sage11: "var(--t-color-transparent-sage11)",
      sage12: "var(--t-color-transparent-sage12)",
      olive1: "var(--t-color-transparent-olive1)",
      olive2: "var(--t-color-transparent-olive2)",
      olive3: "var(--t-color-transparent-olive3)",
      olive4: "var(--t-color-transparent-olive4)",
      olive5: "var(--t-color-transparent-olive5)",
      olive6: "var(--t-color-transparent-olive6)",
      olive7: "var(--t-color-transparent-olive7)",
      olive8: "var(--t-color-transparent-olive8)",
      olive9: "var(--t-color-transparent-olive9)",
      olive10: "var(--t-color-transparent-olive10)",
      olive11: "var(--t-color-transparent-olive11)",
      olive12: "var(--t-color-transparent-olive12)",
      sand1: "var(--t-color-transparent-sand1)",
      sand2: "var(--t-color-transparent-sand2)",
      sand3: "var(--t-color-transparent-sand3)",
      sand4: "var(--t-color-transparent-sand4)",
      sand5: "var(--t-color-transparent-sand5)",
      sand6: "var(--t-color-transparent-sand6)",
      sand7: "var(--t-color-transparent-sand7)",
      sand8: "var(--t-color-transparent-sand8)",
      sand9: "var(--t-color-transparent-sand9)",
      sand10: "var(--t-color-transparent-sand10)",
      sand11: "var(--t-color-transparent-sand11)",
      sand12: "var(--t-color-transparent-sand12)",
      tomato1: "var(--t-color-transparent-tomato1)",
      tomato2: "var(--t-color-transparent-tomato2)",
      tomato3: "var(--t-color-transparent-tomato3)",
      tomato4: "var(--t-color-transparent-tomato4)",
      tomato5: "var(--t-color-transparent-tomato5)",
      tomato6: "var(--t-color-transparent-tomato6)",
      tomato7: "var(--t-color-transparent-tomato7)",
      tomato8: "var(--t-color-transparent-tomato8)",
      tomato9: "var(--t-color-transparent-tomato9)",
      tomato10: "var(--t-color-transparent-tomato10)",
      tomato11: "var(--t-color-transparent-tomato11)",
      tomato12: "var(--t-color-transparent-tomato12)",
      ruby1: "var(--t-color-transparent-ruby1)",
      ruby2: "var(--t-color-transparent-ruby2)",
      ruby3: "var(--t-color-transparent-ruby3)",
      ruby4: "var(--t-color-transparent-ruby4)",
      ruby5: "var(--t-color-transparent-ruby5)",
      ruby6: "var(--t-color-transparent-ruby6)",
      ruby7: "var(--t-color-transparent-ruby7)",
      ruby8: "var(--t-color-transparent-ruby8)",
      ruby9: "var(--t-color-transparent-ruby9)",
      ruby10: "var(--t-color-transparent-ruby10)",
      ruby11: "var(--t-color-transparent-ruby11)",
      ruby12: "var(--t-color-transparent-ruby12)",
      crimson1: "var(--t-color-transparent-crimson1)",
      crimson2: "var(--t-color-transparent-crimson2)",
      crimson3: "var(--t-color-transparent-crimson3)",
      crimson4: "var(--t-color-transparent-crimson4)",
      crimson5: "var(--t-color-transparent-crimson5)",
      crimson6: "var(--t-color-transparent-crimson6)",
      crimson7: "var(--t-color-transparent-crimson7)",
      crimson8: "var(--t-color-transparent-crimson8)",
      crimson9: "var(--t-color-transparent-crimson9)",
      crimson10: "var(--t-color-transparent-crimson10)",
      crimson11: "var(--t-color-transparent-crimson11)",
      crimson12: "var(--t-color-transparent-crimson12)",
      plum1: "var(--t-color-transparent-plum1)",
      plum2: "var(--t-color-transparent-plum2)",
      plum3: "var(--t-color-transparent-plum3)",
      plum4: "var(--t-color-transparent-plum4)",
      plum5: "var(--t-color-transparent-plum5)",
      plum6: "var(--t-color-transparent-plum6)",
      plum7: "var(--t-color-transparent-plum7)",
      plum8: "var(--t-color-transparent-plum8)",
      plum9: "var(--t-color-transparent-plum9)",
      plum10: "var(--t-color-transparent-plum10)",
      plum11: "var(--t-color-transparent-plum11)",
      plum12: "var(--t-color-transparent-plum12)",
      violet1: "var(--t-color-transparent-violet1)",
      violet2: "var(--t-color-transparent-violet2)",
      violet3: "var(--t-color-transparent-violet3)",
      violet4: "var(--t-color-transparent-violet4)",
      violet5: "var(--t-color-transparent-violet5)",
      violet6: "var(--t-color-transparent-violet6)",
      violet7: "var(--t-color-transparent-violet7)",
      violet8: "var(--t-color-transparent-violet8)",
      violet9: "var(--t-color-transparent-violet9)",
      violet10: "var(--t-color-transparent-violet10)",
      violet11: "var(--t-color-transparent-violet11)",
      violet12: "var(--t-color-transparent-violet12)",
      iris1: "var(--t-color-transparent-iris1)",
      iris2: "var(--t-color-transparent-iris2)",
      iris3: "var(--t-color-transparent-iris3)",
      iris4: "var(--t-color-transparent-iris4)",
      iris5: "var(--t-color-transparent-iris5)",
      iris6: "var(--t-color-transparent-iris6)",
      iris7: "var(--t-color-transparent-iris7)",
      iris8: "var(--t-color-transparent-iris8)",
      iris9: "var(--t-color-transparent-iris9)",
      iris10: "var(--t-color-transparent-iris10)",
      iris11: "var(--t-color-transparent-iris11)",
      iris12: "var(--t-color-transparent-iris12)",
      cyan1: "var(--t-color-transparent-cyan1)",
      cyan2: "var(--t-color-transparent-cyan2)",
      cyan3: "var(--t-color-transparent-cyan3)",
      cyan4: "var(--t-color-transparent-cyan4)",
      cyan5: "var(--t-color-transparent-cyan5)",
      cyan6: "var(--t-color-transparent-cyan6)",
      cyan7: "var(--t-color-transparent-cyan7)",
      cyan8: "var(--t-color-transparent-cyan8)",
      cyan9: "var(--t-color-transparent-cyan9)",
      cyan10: "var(--t-color-transparent-cyan10)",
      cyan11: "var(--t-color-transparent-cyan11)",
      cyan12: "var(--t-color-transparent-cyan12)",
      jade1: "var(--t-color-transparent-jade1)",
      jade2: "var(--t-color-transparent-jade2)",
      jade3: "var(--t-color-transparent-jade3)",
      jade4: "var(--t-color-transparent-jade4)",
      jade5: "var(--t-color-transparent-jade5)",
      jade6: "var(--t-color-transparent-jade6)",
      jade7: "var(--t-color-transparent-jade7)",
      jade8: "var(--t-color-transparent-jade8)",
      jade9: "var(--t-color-transparent-jade9)",
      jade10: "var(--t-color-transparent-jade10)",
      jade11: "var(--t-color-transparent-jade11)",
      jade12: "var(--t-color-transparent-jade12)",
      grass1: "var(--t-color-transparent-grass1)",
      grass2: "var(--t-color-transparent-grass2)",
      grass3: "var(--t-color-transparent-grass3)",
      grass4: "var(--t-color-transparent-grass4)",
      grass5: "var(--t-color-transparent-grass5)",
      grass6: "var(--t-color-transparent-grass6)",
      grass7: "var(--t-color-transparent-grass7)",
      grass8: "var(--t-color-transparent-grass8)",
      grass9: "var(--t-color-transparent-grass9)",
      grass10: "var(--t-color-transparent-grass10)",
      grass11: "var(--t-color-transparent-grass11)",
      grass12: "var(--t-color-transparent-grass12)",
      mint1: "var(--t-color-transparent-mint1)",
      mint2: "var(--t-color-transparent-mint2)",
      mint3: "var(--t-color-transparent-mint3)",
      mint4: "var(--t-color-transparent-mint4)",
      mint5: "var(--t-color-transparent-mint5)",
      mint6: "var(--t-color-transparent-mint6)",
      mint7: "var(--t-color-transparent-mint7)",
      mint8: "var(--t-color-transparent-mint8)",
      mint9: "var(--t-color-transparent-mint9)",
      mint10: "var(--t-color-transparent-mint10)",
      mint11: "var(--t-color-transparent-mint11)",
      mint12: "var(--t-color-transparent-mint12)",
      lime1: "var(--t-color-transparent-lime1)",
      lime2: "var(--t-color-transparent-lime2)",
      lime3: "var(--t-color-transparent-lime3)",
      lime4: "var(--t-color-transparent-lime4)",
      lime5: "var(--t-color-transparent-lime5)",
      lime6: "var(--t-color-transparent-lime6)",
      lime7: "var(--t-color-transparent-lime7)",
      lime8: "var(--t-color-transparent-lime8)",
      lime9: "var(--t-color-transparent-lime9)",
      lime10: "var(--t-color-transparent-lime10)",
      lime11: "var(--t-color-transparent-lime11)",
      lime12: "var(--t-color-transparent-lime12)",
      bronze1: "var(--t-color-transparent-bronze1)",
      bronze2: "var(--t-color-transparent-bronze2)",
      bronze3: "var(--t-color-transparent-bronze3)",
      bronze4: "var(--t-color-transparent-bronze4)",
      bronze5: "var(--t-color-transparent-bronze5)",
      bronze6: "var(--t-color-transparent-bronze6)",
      bronze7: "var(--t-color-transparent-bronze7)",
      bronze8: "var(--t-color-transparent-bronze8)",
      bronze9: "var(--t-color-transparent-bronze9)",
      bronze10: "var(--t-color-transparent-bronze10)",
      bronze11: "var(--t-color-transparent-bronze11)",
      bronze12: "var(--t-color-transparent-bronze12)",
      gold1: "var(--t-color-transparent-gold1)",
      gold2: "var(--t-color-transparent-gold2)",
      gold3: "var(--t-color-transparent-gold3)",
      gold4: "var(--t-color-transparent-gold4)",
      gold5: "var(--t-color-transparent-gold5)",
      gold6: "var(--t-color-transparent-gold6)",
      gold7: "var(--t-color-transparent-gold7)",
      gold8: "var(--t-color-transparent-gold8)",
      gold9: "var(--t-color-transparent-gold9)",
      gold10: "var(--t-color-transparent-gold10)",
      gold11: "var(--t-color-transparent-gold11)",
      gold12: "var(--t-color-transparent-gold12)",
      brown1: "var(--t-color-transparent-brown1)",
      brown2: "var(--t-color-transparent-brown2)",
      brown3: "var(--t-color-transparent-brown3)",
      brown4: "var(--t-color-transparent-brown4)",
      brown5: "var(--t-color-transparent-brown5)",
      brown6: "var(--t-color-transparent-brown6)",
      brown7: "var(--t-color-transparent-brown7)",
      brown8: "var(--t-color-transparent-brown8)",
      brown9: "var(--t-color-transparent-brown9)",
      brown10: "var(--t-color-transparent-brown10)",
      brown11: "var(--t-color-transparent-brown11)",
      brown12: "var(--t-color-transparent-brown12)",
      amber1: "var(--t-color-transparent-amber1)",
      amber2: "var(--t-color-transparent-amber2)",
      amber3: "var(--t-color-transparent-amber3)",
      amber4: "var(--t-color-transparent-amber4)",
      amber5: "var(--t-color-transparent-amber5)",
      amber6: "var(--t-color-transparent-amber6)",
      amber7: "var(--t-color-transparent-amber7)",
      amber8: "var(--t-color-transparent-amber8)",
      amber9: "var(--t-color-transparent-amber9)",
      amber10: "var(--t-color-transparent-amber10)",
      amber11: "var(--t-color-transparent-amber11)",
      amber12: "var(--t-color-transparent-amber12)"
    }
  }
}, G = ({ cssVariableReference: r, computedValue: o }) => {
  if (!H(o)) return r;
  const a = Number(o);
  return Number.isNaN(a) ? o : a;
}, h = (r) => {
  if (typeof document > "u" || typeof getComputedStyle != "function") return v;
  const o = getComputedStyle(r ?? document.documentElement), a = (l) => {
    const t = {};
    for (const [c, p] of Object.entries(l)) {
      if (B(p) && p.startsWith("var(")) {
        const i = p.slice(4, -1);
        t[c] = G({
          cssVariableReference: p,
          computedValue: o.getPropertyValue(i).trim()
        });
        continue;
      }
      t[c] = A(p) ? a(p) : p;
    }
    return t;
  };
  return a(v);
}, _, b = () => _ ??= e.createContext({
  theme: v,
  colorScheme: "light"
}), N, q = () => N ??= e.createContext(null), R = (r) => P(r.spacing), O = (r, o) => {
  const a = { ...r };
  for (const l in a) a[l] = o(Number(l));
  return a;
}, W = (r) => R(r) ? {
  ...r,
  spacing: O(v.spacing, r.spacing)
} : r, z = (r) => {
  if (typeof document > "u") return;
  const o = document.documentElement;
  o?.classList && (o.classList.toggle("dark", r === "dark"), o.classList.toggle("light", r === "light"));
}, pr = ({ children: r, colorScheme: o, applyToRoot: a = !0, overrides: l, className: t, scale: c, theme: p }) => {
  const i = b(), j = q(), s = n(l) || !a, f = e.useContext(i), d = e.useMemo(() => n(p) ? W(p) : void 0, [p]) ?? f.explicitTheme, g = n(d), u = e.useRef(null), [C, S] = e.useState(() => (a && z(o), g ? void 0 : h())), [T, I] = e.useState(null), M = n(l) ? JSON.stringify(l) : "";
  e.useLayoutEffect(() => {
    a && z(o), g || S(h(s ? u.current ?? void 0 : void 0)), I(s ? u.current : null);
  }, [
    o,
    a,
    s,
    M,
    g
  ]), e.useLayoutEffect(() => {
    if (typeof document > "u" || s || !n(c)) return;
    const x = document.documentElement;
    return x.style.setProperty("--t-scale-user", String(c)), () => {
      x.style.removeProperty("--t-scale-user");
    };
  }, [c, s]);
  const k = d ?? C ?? f.theme, w = e.useMemo(() => ({
    theme: k,
    colorScheme: o,
    explicitTheme: d
  }), [
    k,
    o,
    d
  ]);
  if (!s) return /* @__PURE__ */ y(i.Provider, {
    value: w,
    children: r
  });
  const E = l ?? {};
  return /* @__PURE__ */ y(i.Provider, {
    value: w,
    children: /* @__PURE__ */ y(j.Provider, {
      value: T,
      children: /* @__PURE__ */ y("div", {
        ref: u,
        className: L(a ? void 0 : o, t),
        style: {
          display: "contents",
          ...E
        },
        children: r
      })
    })
  });
}, tr = () => e.useContext(b()).theme, cr = () => e.useContext(b()).colorScheme, sr = () => e.useContext(q());
export {
  v as a,
  ar as c,
  X as d,
  Q as f,
  Z as g,
  Y as h,
  pr as i,
  or as l,
  J as m,
  cr as n,
  er as o,
  U as p,
  tr as r,
  lr as s,
  sr as t,
  rr as u
};
